"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function asyncGeneratorStep(e, t, n, a, r, i, o) {
  try {
    var s = e[i](o),
      l = s.value;
  } catch (e) {
    return void n(e);
  }
  s.done ? t(l) : Promise.resolve(l).then(a, r);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      n = arguments;
    return new Promise(function (a, r) {
      var i = e.apply(t, n);
      function o(e) {
        asyncGeneratorStep(i, a, r, o, s, "next", e);
      }
      function s(e) {
        asyncGeneratorStep(i, a, r, o, s, "throw", e);
      }
      o(void 0);
    });
  };
}
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var a = t[n];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
  }
}
function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}
var convert = require("xml-js"),
  axios = require("axios"),
  flatten = require("flat"),
  unflatten = require("flat").unflatten,
  mapper = require("./helper/mapper"),
  backendService = require("./Backend.service"),
  utilityModule = require("./Utility.module"),
  StillWaterHelper = require("./helper/StillWaterHelper"),
  SbliHelper = require("./helper/SbliHelper"),
  WnsHelper = require("./helper/WnsHelper"),
  CriticalInput = require("./CriticalInput.service");
mapper = new mapper.Mapper();
var packlifeUidKey = ["faceAmount", "dob", "riskClass", "premiumFrequency", "state", "gender", "productCode", "smoker"],
  sbliUidKey = ["quoteRateClassRequest", "distributorId", "productId", "gender", "dob", "term", "zip", "state", "height", "weight", "healthStatusRank", "tobaccoUse", "coverage", "benefitLength", "channel", "ipAddress"],
  stillwaterUidKey = ["firstName", "middleName", "lastName", "addressType", "address", "city", "state", "coverage", "zip"],
  totalFast = 0,
  totalFlexi = 0,
  totalAffordable = 0,
  paclifeError = !1,
  sbliError = !1,
  swError = !1,
  Quote = function () {
    return _createClass(function e(t, n) {
      _classCallCheck(this, e), this.id = t, this.envObject = n;
    }, [{
      key: "getQuickQuote2",
      value: (te = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g,
          _,
          y,
          h,
          w,
          C = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              for (l in n = C.length > 1 && void 0 !== C[1] && C[1], a = C.length > 2 && void 0 !== C[2] && C[2], backendService.getPaclifeURL(this.envObject), console.log("getQuickQuote2:commonInput:pacLife: ", t), r = [], i = {
                address: "285 Bryant St",
                addressType: "PhysicalRisk",
                city: "Palo Alto",
                coverage: "1000000",
                dob: "01/01/2000",
                firstName: "Anonymous",
                gender: "M",
                height: "5ft 10inch",
                lastName: "Lastname",
                middleName: "User",
                premiumFrequency: "m",
                riskClass: "Standard Non-Tobacco",
                state: "CA",
                term: "20",
                tobaccoUse: 5,
                weight: 180,
                zip: "94301"
              }, o = {}, s = {}, Object.assign(o, t), Object.assign(s, t), console.log("commaninput_in_libarary", s), i) o[l] || (o[l] = i[l]);
              for (p in u = (u = this.id.split("-"))[0], c = utilityModule.getQuoteId(u), m = {}, o) m[p] = o[p];
              return m.address = i.address, m.addressType = i.addressType, m.city = i.city, m.state = i.state, m.zip = i.zip, (_ = o.coverage) && (_ = _.replace("$", "").replace(/,/g, "").replace(/ /g, ""), o.coverage = _), y = mapper.mapdata(this.id, "paclife", o), "M" == o.gender ? y.gender = "Male" : y.gender = "Female", o.dob && -1 !== o.dob.indexOf("NaN") && (y.dob = "2003-01-01"), h = [], n && Number(_) <= 1e6 && h.push(this.getSbliquotes(s, u)), a && h.push(this.getWnsquotes(s, u)), e.next = 33, Promise.all(h).then(function (e) {
                console.log("promiseall", e), w = e;
              });
            case 33:
              return d = n && Number(_) <= 1e6 ? w[0] : void 0, g = a && n && Number(_) <= 1e6 ? w[1] : w[0], 65 - Number(this.getAge(o.dob)), this.getAge(o.dob), o.gender, r = a ? [{
                quoteId: c,
                carrierId: "sbli",
                head: {
                  carrier_name: "SBLI Term",
                  quote_amount: d && d.sbliAmount ? d.sbliAmount : "$0",
                  annual_amount: d && d.sbliannualamount ? d.sbliannualamount : "$0",
                  carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/sbli-logo-vfd737.svg"
                },
                body: {
                  points: [{
                    highlight: "You are covered up to age 55 (based on your current age)"
                  }, {
                    highlight: "Completely digital experience with no medical exam, phone calls or in-person appointments required."
                  }, {
                    highlight: "100% online decision in minutes."
                  }]
                },
                selectedDetails: {
                  term: s.term,
                  coverage: s.coverage,
                  title: "Key Benefits",
                  text: "An easy online application that you can start and finish in minutes, with a decision on the spot.",
                  key_benefits: [{
                    title: "Trusted Carrier",
                    text: "SBLI has protected over a million families with rock-solid financial strength since our founding. As a mutual company, we are owned by our policyholders and we always place our customers’ needs first."
                  }, {
                    title: "Simple",
                    text: "An easy online application that you can start and finish in minutes, at home, at your kids’ soccer game, or just about anywhere. Plus, our Simplified Issue process means you get a decision on the spot, while you wait. No follow-up is needed."
                  }, {
                    title: "Guaranteed Premiums",
                    text: "Premiums that stay the same for the selected initial term period. Plus, at the end of this level period, the policy can be continued to age 85 at annually increasing rates."
                  }],
                  footer_text: [{
                    text: 'Policies are issued by The Savings Bank Mutual Life Insurance Company of Massachusetts (“SBLI”) on policy form series 21-P-SIT. Centrian Life Insurance is a registered trade name and Connecticut d/b/a of SBLI. Policies sold in the state of Connecticut will be issued under Centrian Life Insurance ("Centrian*"). The premium quotes displayed here are non-binding and based on some preliminary personal information. The final insurance policy premium for any policy is determined following the applicant completing the full application process.'
                  }]
                },
                hasError: !(!d || !d.sbliError) && d.sbliError,
                sbliQuoteFlag: n
              }, {
                quoteId: c,
                carrierId: "wns",
                head: {
                  carrier_name: "Western & Southern",
                  quote_amount: g && g.sbliAmount ? g.sbliAmount : "$0",
                  annual_amount: g && g.sbliannualamount ? g.sbliannualamount : "$0",
                  carrier_icon: "https://www.westernsouthern.com/-/media/feature/westernsouthern/globals/logos/company-logo.svg?rev=f4cdd70b3b8d4afaad16c5a891f2a0a1&origin=https://www.westernsouthern.com&la=en&hash=9299106AEA340FA17C4DCF0FE4168242"
                },
                body: {
                  points: [{
                    highlight: "You are covered up to age 55 (based on your current age)"
                  }, {
                    highlight: "Completely digital experience with no medical exam, phone calls or in-person appointments required."
                  }, {
                    highlight: "100% online decision in minutes."
                  }]
                },
                selectedDetails: {
                  term: s.wnsterm,
                  coverage: g.sbliCoverage,
                  title: "Key Benefits",
                  text: "An easy online application that you can start and finish in minutes, with a decision on the spot.",
                  key_benefits: [{
                    title: "Trusted Carrier",
                    text: "SBLI has protected over a million families with rock-solid financial strength since our founding. As a mutual company, we are owned by our policyholders and we always place our customers’ needs first."
                  }, {
                    title: "Simple",
                    text: "An easy online application that you can start and finish in minutes, at home, at your kids’ soccer game, or just about anywhere. Plus, our Simplified Issue process means you get a decision on the spot, while you wait. No follow-up is needed."
                  }, {
                    title: "Guaranteed Premiums",
                    text: "Premiums that stay the same for the selected initial term period. Plus, at the end of this level period, the policy can be continued to age 85 at annually increasing rates."
                  }],
                  footer_text: [{
                    text: 'Policies are issued by The Savings Bank Mutual Life Insurance Company of Massachusetts (“SBLI”) on policy form series 21-P-SIT. Centrian Life Insurance is a registered trade name and Connecticut d/b/a of SBLI. Policies sold in the state of Connecticut will be issued under Centrian Life Insurance ("Centrian*"). The premium quotes displayed here are non-binding and based on some preliminary personal information. The final insurance policy premium for any policy is determined following the applicant completing the full application process.'
                  }]
                },
                hasError: !(!g || !g.sbliError) && g.sbliError,
                sbliQuoteFlag: n
              }] : [{
                quoteId: c,
                carrierId: "sbli",
                head: {
                  carrier_name: "SBLI Term",
                  quote_amount: d && d.sbliAmount ? d.sbliAmount : "$0",
                  annual_amount: d && d.sbliannualamount ? d.sbliannualamount : "$0",
                  carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/sbli-logo-vfd737.svg"
                },
                body: {
                  points: [{
                    highlight: "You are covered up to age 55 (based on your current age)"
                  }, {
                    highlight: "Completely digital experience with no medical exam, phone calls or in-person appointments required."
                  }, {
                    highlight: "100% online decision in minutes."
                  }]
                },
                selectedDetails: {
                  term: s.term,
                  coverage: s.coverage,
                  title: "Key Benefits",
                  text: "An easy online application that you can start and finish in minutes, with a decision on the spot.",
                  key_benefits: [{
                    title: "Trusted Carrier",
                    text: "SBLI has protected over a million families with rock-solid financial strength since our founding. As a mutual company, we are owned by our policyholders and we always place our customers’ needs first."
                  }, {
                    title: "Simple",
                    text: "An easy online application that you can start and finish in minutes, at home, at your kids’ soccer game, or just about anywhere. Plus, our Simplified Issue process means you get a decision on the spot, while you wait. No follow-up is needed."
                  }, {
                    title: "Guaranteed Premiums",
                    text: "Premiums that stay the same for the selected initial term period. Plus, at the end of this level period, the policy can be continued to age 85 at annually increasing rates."
                  }],
                  footer_text: [{
                    text: 'Policies are issued by The Savings Bank Mutual Life Insurance Company of Massachusetts (“SBLI”) on policy form series 21-P-SIT. Centrian Life Insurance is a registered trade name and Connecticut d/b/a of SBLI. Policies sold in the state of Connecticut will be issued under Centrian Life Insurance ("Centrian*"). The premium quotes displayed here are non-binding and based on some preliminary personal information. The final insurance policy premium for any policy is determined following the applicant completing the full application process.'
                  }]
                },
                hasError: !(!d || !d.sbliError) && d.sbliError,
                sbliQuoteFlag: n
              }], e.abrupt("return", r);
            case 41:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return te.apply(this, arguments);
      })
    }, {
      key: "getSbliQuote",
      value: (ee = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i, o, s, l;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), a = utilityModule.getQuoteId(n), (r = t.coverage) && (r = r.replace("$", "").replace(/,/g, "").replace(/ /g, ""), t.coverage = r), o = new SbliHelper.SbliHelper(n), e.next = 7, backendService.getAppData(n);
            case 7:
              if (s = e.sent, s = (s = JSON.parse(s.Payload)).body, this.getAge(t.dob), null == s.arcId || null == s.arcId || "" == s.arcId) {
                e.next = 17;
                break;
              }
              return e.next = 14, o.getQuote(t, s.arcId);
            case 14:
              i = e.sent, e.next = 20;
              break;
            case 17:
              return e.next = 19, o.getQuote(t);
            case 19:
              i = e.sent;
            case 20:
              return l = [{
                quoteId: a,
                carrierId: "sbli",
                head: {
                  carrier_name: "SBLI Term",
                  quote_amount: i && i.sbliAmount ? i.sbliAmount : "$0",
                  annual_amount: i && i.sbliannualamount ? i.sbliannualamount : "$0",
                  carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/sbli-logo-vfd737.svg"
                },
                body: {
                  points: [{
                    highlight: "You are covered up to age 55 (based on your current age)"
                  }, {
                    highlight: "Completely digital experience with no medical exam, phone calls or in-person appointments required."
                  }, {
                    highlight: "100% online decision in minutes."
                  }]
                },
                selectedDetails: {
                  term: t.term,
                  coverage: t.coverage,
                  title: "Key Benefits",
                  text: "An easy online application that you can start and finish in minutes, with a decision on the spot.",
                  key_benefits: [{
                    title: "Trusted Carrier",
                    text: "SBLI has protected over a million families with rock-solid financial strength since our founding. As a mutual company, we are owned by our policyholders and we always place our customers’ needs first. "
                  }, {
                    title: "Simple",
                    text: "An easy online application that you can start and finish in minutes, at home, at your kids’ soccer game, or just about anywhere. Plus, our Simplified Issue process means you get a decision on the spot, while you wait. No follow-up is needed."
                  }, {
                    title: "Guaranteed Premiums",
                    text: "Premiums that stay the same for the selected initial term period. Plus, at the end of this level period, the policy can be continued to age 85 at annually increasing rates."
                  }],
                  footer_text: [{
                    text: 'Policies are issued by The Savings Bank Mutual Life Insurance Company of Massachusetts (“SBLI”) on policy form series 21-P-SIT. Centrian Life Insurance is a registered trade name and Connecticut d/b/a of SBLI. Policies sold in the state of Connecticut will be issued under Centrian Life Insurance ("Centrian*"). The premium quotes displayed here are non-binding and based on some preliminary personal information. The final insurance policy premium for any policy is determined following the applicant completing the full application process.'
                  }]
                },
                hasError: !(!i || !i.sbliError) && i.sbliError,
                sbliQuoteFlag: !0
              }], e.abrupt("return", l);
            case 23:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return ee.apply(this, arguments);
      })
    }, {
      key: "getWnsQuote",
      value: (j = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i, o, s, l;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), a = utilityModule.getQuoteId(n), (r = t.coverage) && (r = r.replace("$", "").replace(/,/g, "").replace(/ /g, ""), t.coverage = r), o = new WnsHelper.WnsHelper(this.getClientId()), e.next = 7, backendService.getAppData(n);
            case 7:
              if (s = e.sent, s = (s = JSON.parse(s.Payload)).body, this.getAge(t.dob), null == s.wnsarcId || null == s.wnsarcId || "" == s.wnsarcId) {
                e.next = 17;
                break;
              }
              return e.next = 14, o.getQuote(t, s.wnsarcId);
            case 14:
              i = e.sent, e.next = 20;
              break;
            case 17:
              return e.next = 19, o.getQuote(t);
            case 19:
              i = e.sent;
            case 20:
              return l = [{
                quoteId: a,
                carrierId: "wns",
                head: {
                  carrier_name: "Western & Southern",
                  quote_amount: i && i.sbliAmount ? i.sbliAmount : "$0",
                  annual_amount: i && i.sbliannualamount ? i.sbliannualamount : "$0",
                  carrier_icon: "https://www.westernsouthern.com/-/media/feature/westernsouthern/globals/logos/company-logo.svg?rev=f4cdd70b3b8d4afaad16c5a891f2a0a1&origin=https://www.westernsouthern.com&la=en&hash=9299106AEA340FA17C4DCF0FE4168242"
                },
                body: {
                  points: [{
                    highlight: "You are covered up to age 55 (based on your current age)"
                  }, {
                    highlight: "Completely digital experience with no medical exam, phone calls or in-person appointments required."
                  }, {
                    highlight: "100% online decision in minutes."
                  }]
                },
                selectedDetails: {
                  term: sbliCommonInput.term,
                  coverage: i.sbliCoverage,
                  title: "Key Benefits",
                  text: "An easy online application that you can start and finish in minutes, with a decision on the spot.",
                  key_benefits: [{
                    title: "Trusted Carrier",
                    text: "SBLI has protected over a million families with rock-solid financial strength since our founding. As a mutual company, we are owned by our policyholders and we always place our customers’ needs first."
                  }, {
                    title: "Simple",
                    text: "An easy online application that you can start and finish in minutes, at home, at your kids’ soccer game, or just about anywhere. Plus, our Simplified Issue process means you get a decision on the spot, while you wait. No follow-up is needed."
                  }, {
                    title: "Guaranteed Premiums",
                    text: "Premiums that stay the same for the selected initial term period. Plus, at the end of this level period, the policy can be continued to age 85 at annually increasing rates."
                  }],
                  footer_text: [{
                    text: 'Policies are issued by The Savings Bank Mutual Life Insurance Company of Massachusetts (“SBLI”) on policy form series 21-P-SIT. Centrian Life Insurance is a registered trade name and Connecticut d/b/a of SBLI. Policies sold in the state of Connecticut will be issued under Centrian Life Insurance ("Centrian*"). The premium quotes displayed here are non-binding and based on some preliminary personal information. The final insurance policy premium for any policy is determined following the applicant completing the full application process.'
                  }]
                },
                hasError: !(!i || !i.sbliError) && i.sbliError,
                sbliQuoteFlag: sbliQuoteFlag
              }], e.abrupt("return", l);
            case 23:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return j.apply(this, arguments);
      })
    }, {
      key: "getStillWaterQuote",
      value: (Z = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g,
          _,
          y,
          h,
          w,
          C,
          v,
          S,
          b,
          A,
          x,
          f,
          P,
          I,
          T,
          O,
          N,
          R,
          k,
          H,
          D,
          W,
          L,
          F,
          M,
          E,
          B,
          G,
          q,
          U,
          Q,
          J,
          $ = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = $.length > 1 && void 0 !== $[1] && $[1], a = $.length > 2 && void 0 !== $[2] && $[2], r = $.length > 3 && void 0 !== $[3] && $[3], this.saveCommonInput(t), i = this.getClientId(), o = utilityModule.getQuoteId(i), s = ["economy", "best", "expanded"], l = ["PRIMARY", "POPULAR", "PREMIUM"], u = this.getAge("01/01/" + t.yearbuilt), console.log("homeAgehomeAge", u), c = "03", u > 50 && (s = ["economy", "best"]), t.hasOwnProperty("swquote_question") && (t.swquote_question.includes(25) || t.swquote_question.includes(43)) && (console.log("getStillWaterQuote only for economy & best due to 25, 43"), s = ["economy", "best"]), n && (console.log("getStillWaterQuote only for checkProperty"), s = ["economy"]), m = new StillWaterHelper.StillWaterHelper(), p = {}, d = "", g = {}, _ = 0, y = 0, h = 0, w = [], C = {}, v = "", S = {}, b = !1, A = 0, x = 0, f = {}, P = "", I = "", T = "", e.next = 36, backendService.getAppData(i);
            case 36:
              O = e.sent, O = (O = JSON.parse(O.Payload)).body, n ? I = "" : (I = O.swQuoteId, console.log("Got existing swQuoteId", I)), O.stillwater && unflatten(O.stillwater), N = "no", N = O.brushForestError ? O.brushForestError : "no", R = this.getSWPlansText(), k = !1, 2 == s.length && (k = !0, s = ["economy", "best", "expanded"]), r && (s = ["plan_4"], l = ["PLAN_4"]), H = [], D = [], W = 0, L = new Date(), F = L.getTime(), M = _regeneratorRuntime.mark(function e(n) {
                return _regeneratorRuntime.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return c = "expanded" == s[n] ? k ? "03" : "05" : "03", "FL" == t.state && (c = u > 50 ? "05" : "03"), e.next = 4, utilityModule.getClientId();
                    case 4:
                      e.sent, "CD" == t.propertyDetails.home_type && (c = "06"), D.push(new Promise(function (e) {
                        return setTimeout(e, W);
                      }).then(function () {
                        return m.getRecommendedSWQuote(t, c, s[n], o, o + "_" + s[n], I, N);
                      })), W += 50;
                    case 8:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }), E = 0;
            case 54:
              if (!(E < s.length)) {
                e.next = 59;
                break;
              }
              return e.delegateYield(M(E), "t0", 56);
            case 56:
              E++, e.next = 54;
              break;
            case 59:
              return e.next = 61, Promise.all(D);
            case 61:
              for (H = e.sent, console.log("swOutputArray_01", H), B = new Date(), G = B.getTime(), console.log("SW calls done", Math.floor((G - F) / 1e3) + " seconds"), a && (H.length = 1), q = 0; q < H.length; q++) p = {}, b = !1, d = "", g = {}, _ = 0, C = {}, v = "", x = 0, f = {}, P = "", T = "", y = 0, h = 0, g = H[q], p = g.swOutput, console.log("swOutput", p), C = g.commonCoverages, p.hasOwnProperty("ACORD") && (!(p = p.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs).hasOwnProperty("MsgStatus") || "Error" != p.MsgStatus.MsgStatusCd._text && "Rejected" != p.MsgStatus.MsgStatusCd._text ? p.hasOwnProperty("HomeLineBusiness") && (I = p.PersPolicy.QuoteInfo.CompanysQuoteNumber._text, console.log("getStillWaterQuote policyId for further use ", I), v = (v = p.HomeLineBusiness.Dwell.Coverage.filter(function (e) {
                return "DWELL" == e.CoverageCd._text;
              })[0]).Limit.FormatInteger._text, C.final_dwell = v, S["swQuote_" + s[q]] = {
                swResponseJson: g.swOutput,
                commonCoverages: C
              }, T = p.HomeLineBusiness.Dwell.Coverage.filter(function (e) {
                return "LOU" == e.CoverageCd._text;
              })[0], T = "CO" == t.state && "06" != C.homeType ? 40 : T.Limit.FormatInteger._text, _ = p.PersPolicy.PaymentOption.filter(function (e) {
                return "com.stillwater_EF12" == e.PaymentPlanCd._text;
              })[0], y = ((y = p.PolicySummaryInfo.FullTermAmt.Amt._text) / 12).toFixed(0), p.PolicySummaryInfo["com.stillwater_PackagePremium"].Amt && (h = ((h = p.PolicySummaryInfo["com.stillwater_PackagePremium"].Amt._text) / 12).toFixed(0)), U = Number(_.TotalPremium._text.replace(/[^0-9.-]+/g, "")), console.log("newMonthlyPremium", U), U = (U / 12).toFixed(2), console.log("newMonthlyPremium", U), _ = U, x = p.HomeLineBusiness.Dwell.TotalInsurableReplCostAmt.Amt._text, console.log(s[q], _, v, c, x, I)) : (d = p.MsgStatus.MsgStatusDesc._text, console.log("kun===========", s[q], d), d.includes("Exception") && (b = !0))), (0 == _ || _ <= 0) && (b = !0), A = "06" == C.homeType ? +C.personal_property : (+v * +C.personal_property / 100).toFixed(0), f = m.getDynamicLabels(C), P = m.getHcbData(C), Q = void 0, J = void 0, "AZ" == t.state || "NJ" == t.state || "FL" == t.state ? (Q = "Covered", J = m.getSWToolTips("identity_recovery")) : "TX" == t.state || "VA" == t.state || "OH" == t.state ? (Q = C.identity_recovery ? "$" + this.numberWithCommas(C.identity_recovery) : "Not Covered", J = m.getSWToolTips("identity_recovery"), console.log("identityTheft_00900", Q)) : (Q = C.identity_protection ? "$" + this.numberWithCommas(C.identity_protection) : "Not Covered", J = m.getSWToolTips("identity_protection")), w.push({
                policyType: c,
                quoteId: o + "_" + s[q],
                carrierId: s[q],
                replacementCost: "$" + this.numberWithCommas(x),
                loss_of_use: "06" == C.homeType ? "$" + this.numberWithCommas(parseInt(T)) : "$" + this.numberWithCommas(parseInt(40 * +x / 100)),
                quoteLabels: f,
                head: {
                  carrier_name: l[q],
                  home_insurance_carrier: "Stillwater",
                  quote_amount: _,
                  packagePremium: y,
                  packagePremiumDiscounted: h,
                  carrier_icon: "",
                  grade: "A+",
                  grade_text: "A.M Best"
                },
                body: {
                  text: R[s[q]],
                  other_amounts: {
                    deductible: {
                      title: "Deductible",
                      text: "$" + this.numberWithCommas(C.deductible),
                      help_text: m.getSWToolTips("deductible")
                    },
                    liability: {
                      title: "Liability Coverage",
                      text: "$" + this.numberWithCommas(C.liability),
                      help_text: m.getSWToolTips("liability")
                    },
                    personal_prop: {
                      title: "Personal Property",
                      text: "$" + this.numberWithCommas(A),
                      help_text: m.getSWToolTips("personal_property")
                    },
                    dwelling: {
                      title: "Dwelling Coverage",
                      text: "$" + this.numberWithCommas(v),
                      help_text: m.getSWToolTips("dwelling")
                    }
                  }
                },
                planDetails: {
                  text: "Stillwater's Homeowners Insurance includes extensive coverage that provides peace of mind. All this at an affordable cost with additional discounts that help you save.",
                  coverages: {
                    medical_payment: C.medical_payment ? "$" + this.numberWithCommas(C.medical_payment) : "Not Covered",
                    water_backup: C.water_backup ? "$" + this.numberWithCommas(C.water_backup) : "Not Covered",
                    hcb: P,
                    homesystem: C.homesys_protect ? "$" + this.numberWithCommas(C.homesys_protect[0]) + "(Deductible $" + this.numberWithCommas(C.homesys_protect[1]) + ")" : "Not Covered",
                    id_protection: Q,
                    service_line: C.serviceline ? "$" + this.numberWithCommas(C.serviceline[0]) + "(Deductible $" + this.numberWithCommas(C.serviceline[1]) + ")" : "Not Covered",
                    medical_payment_help_text: m.getSWToolTips("medical_payment"),
                    water_backup_help_text: m.getSWToolTips("water_backup"),
                    hcb_help_text: m.getSWToolTips("home_cyberbase"),
                    homesystem_help_text: m.getSWToolTips("homesys_protect"),
                    id_protection_help_text: J,
                    service_line_help_text: m.getSWToolTips("serviceline")
                  }
                },
                errorMessage: d,
                hasError: b
              });
              return console.log("flattenedJson222", S), S = flatten(S), S = flatten(S), e.next = 73, backendService.saveUpdateClientData(i, {
                swQuoteId: I,
                id: i,
                clientId: i,
                uid: i
              });
            case 73:
              return e.next = 75, backendService.saveUpdateClientData(i, {
                swQuotes: S,
                id: i,
                clientId: i,
                uid: i
              });
            case 75:
              return e.abrupt("return", w);
            case 76:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return Z.apply(this, arguments);
      })
    }, {
      key: "getStillWaterQuoteFourthPlan",
      value: (Y = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g,
          _,
          y,
          h,
          w,
          C,
          v,
          S,
          b,
          A,
          x,
          f,
          P,
          I,
          T,
          O,
          N,
          R,
          k,
          H,
          D,
          W,
          L,
          F,
          M,
          E,
          B,
          G,
          q,
          U,
          Q = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = Q.length > 1 && void 0 !== Q[1] && Q[1], a = Q.length > 2 && void 0 !== Q[2] && Q[2], this.saveCommonInput(t), r = this.getClientId(), i = utilityModule.getQuoteId(r), o = ["economy"], s = ["STILLWATER"], l = this.getAge("01/01/" + t.yearbuilt), u = "03", l > 50 && (o = ["economy"]), t.hasOwnProperty("swquote_question") && (t.swquote_question.includes(25) || t.swquote_question.includes(43)) && (o = ["economy"]), n && (console.log("getStillWaterQuote only for checkProperty"), o = ["economy"]), c = new StillWaterHelper.StillWaterHelper(), m = {}, p = "", d = {}, g = 0, _ = 0, y = 0, h = [], w = {}, C = "", v = {}, S = !1, b = 0, A = 0, x = {}, f = "", P = "", e.next = 33, backendService.getAppData(r);
            case 33:
              I = e.sent, I = (I = JSON.parse(I.Payload)).body, P = n ? "" : I.swQuoteId, I.stillwater && unflatten(I.stillwater), T = "no", T = I.brushForestError ? I.brushForestError : "no", O = this.getSWPlansText(), N = !1, 2 == o.length && (N = !0, o = ["economy"]), R = [], k = [], H = 0, D = new Date(), W = D.getTime(), L = _regeneratorRuntime.mark(function e(n) {
                return _regeneratorRuntime.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return u = "expanded" == o[n] ? N ? "03" : "05" : "03", "FL" == t.state && (u = l > 50 ? "05" : "03"), e.next = 4, utilityModule.getClientId();
                    case 4:
                      e.sent, k.push(new Promise(function (e) {
                        return setTimeout(e, H);
                      }).then(function () {
                        return c.getRecommendedSWQuoteFourthPlan(t, u, o[n], i, i + "_" + o[n], "", T);
                      })), H += 50;
                    case 7:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }), F = 0;
            case 50:
              if (!(F < o.length)) {
                e.next = 55;
                break;
              }
              return e.delegateYield(L(F), "t0", 52);
            case 52:
              F++, e.next = 50;
              break;
            case 55:
              return e.next = 57, Promise.all(k);
            case 57:
              for (R = e.sent, M = new Date(), E = M.getTime(), console.log("SW calls done", Math.floor((E - W) / 1e3) + " seconds"), a && (R.length = 1), B = 0; B < R.length; B++) m = {}, S = !1, p = "", d = {}, g = 0, w = {}, C = "", A = 0, x = {}, f = "", _ = 0, y = 0, d = R[B], m = d.swOutput, w = d.commonCoverages, !(m = m.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs).hasOwnProperty("MsgStatus") || "Error" != m.MsgStatus.MsgStatusCd._text && "Rejected" != m.MsgStatus.MsgStatusCd._text ? m.hasOwnProperty("HomeLineBusiness") && (P = m.PersPolicy.QuoteInfo.CompanysQuoteNumber._text, C = (C = m.HomeLineBusiness.Dwell.Coverage.filter(function (e) {
                return "DWELL" == e.CoverageCd._text;
              })[0]).Limit.FormatInteger._text, w.final_dwell = C, v["swQuote_" + o[B]] = {
                swResponseJson: d.swOutput,
                commonCoverages: w
              }, g = m.PersPolicy.PaymentOption.filter(function (e) {
                return "com.stillwater_EF12" == e.PaymentPlanCd._text;
              })[0], _ = ((_ = m.PolicySummaryInfo.FullTermAmt.Amt._text) / 12).toFixed(0), console.log("sadsadsads", m.PolicySummaryInfo["com.stillwater_PackagePremium"]), m.PolicySummaryInfo["com.stillwater_PackagePremium"].Amt && (y = ((y = m.PolicySummaryInfo["com.stillwater_PackagePremium"].Amt._text) / 12).toFixed(0)), G = ((G = Number(g.TotalPremium._text.replace(/[^0-9.-]+/g, ""))) / 12).toFixed(2), g = G, A = m.HomeLineBusiness.Dwell.TotalInsurableReplCostAmt.Amt._text) : (p = m.MsgStatus.MsgStatusDesc._text, console.log(o[B], p), p.includes("Exception") && (S = !0)), (0 == g || g <= 0) && (S = !0), b = (+C * +w.personal_property / 100).toFixed(0), x = c.getDynamicLabels(w), f = c.getHcbData(w), q = void 0, U = void 0, "AZ" == t.state || "NJ" == t.state || "FL" == t.state ? (q = "Covered", U = c.getSWToolTips("identity_recovery")) : "TX" == t.state || "VA" == t.state || "OH" == t.state ? (q = w.identity_recovery ? "$" + this.numberWithCommas(w.identity_recovery) : "Not Covered", U = c.getSWToolTips("identity_recovery")) : (q = w.identity_protection ? "$" + this.numberWithCommas(w.identity_protection) : "Not Covered", U = c.getSWToolTips("identity_protection")), h.push({
                policyType: u,
                quoteId: i + "_" + o[B],
                carrierId: o[B],
                replacementCost: "$" + this.numberWithCommas(A),
                loss_of_use: "$" + this.numberWithCommas(parseInt(40 * +A / 100)),
                quoteLabels: x,
                head: {
                  carrier_name: s[B],
                  home_insurance_carrier: "Stillwater",
                  quote_amount: g,
                  packagePremium: _,
                  packagePremiumDiscounted: y,
                  carrier_icon: "",
                  grade: "A+",
                  grade_text: "A.M Best"
                },
                body: {
                  text: O[o[B]],
                  other_amounts: {
                    deductible: {
                      title: "Deductible",
                      text: "$" + this.numberWithCommas(w.deductible),
                      help_text: c.getSWToolTips("deductible")
                    },
                    liability: {
                      title: "Liability Coverage",
                      text: "$" + this.numberWithCommas(w.liability),
                      help_text: c.getSWToolTips("liability")
                    },
                    personal_prop: {
                      title: "Personal Property",
                      text: "$" + this.numberWithCommas(b),
                      help_text: c.getSWToolTips("personal_property")
                    },
                    dwelling: {
                      title: "Dwelling Coverage",
                      text: "$" + this.numberWithCommas(C),
                      help_text: c.getSWToolTips("dwelling")
                    }
                  }
                },
                planDetails: {
                  text: "Stillwater's Homeowners Insurance includes extensive coverage that provides peace of mind. All this at an affordable cost with additional discounts that help you save.",
                  coverages: {
                    medical_payment: w.medical_payment ? "$" + this.numberWithCommas(w.medical_payment) : "Not Covered",
                    water_backup: w.water_backup ? "$" + this.numberWithCommas(w.water_backup) : "Not Covered",
                    hcb: f,
                    homesystem: w.homesys_protect ? "$" + this.numberWithCommas(w.homesys_protect[0]) + "/ $" + this.numberWithCommas(w.homesys_protect[1]) : "Not Covered",
                    id_protection: q,
                    service_line: w.serviceline ? "$" + this.numberWithCommas(w.serviceline[0]) + "/ $" + this.numberWithCommas(w.serviceline[1]) : "Not Covered",
                    medical_payment_help_text: c.getSWToolTips("medical_payment"),
                    water_backup_help_text: c.getSWToolTips("water_backup"),
                    hcb_help_text: c.getSWToolTips("home_cyberbase"),
                    homesystem_help_text: c.getSWToolTips("homesys_protect"),
                    id_protection_help_text: U,
                    service_line_help_text: c.getSWToolTips("serviceline")
                  }
                },
                errorMessage: p,
                hasError: S
              });
              return v = flatten(v), e.next = 66, backendService.saveUpdateClientData(r, {
                swQuoteId: P,
                id: r,
                clientId: r,
                uid: r
              });
            case 66:
              return e.next = 68, backendService.saveUpdateClientData(r, {
                swQuotes: v,
                id: r,
                clientId: r,
                uid: r
              });
            case 68:
              return console.log("quotesFourth", h), e.abrupt("return", h);
            case 70:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return Y.apply(this, arguments);
      })
    }, {
      key: "swQuoteKnockout",
      value: (K = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i, o, s, l, u, c, m, p, d, g, _, y, h, w, C, v;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return this.saveCommonInput(t), n = {
                375: "com.stillwater_ExistingDamage",
                525: "com.stillwater_MultiFamily",
                25: "com.stillwater_CoverageLapse",
                43: "com.stillwater_NonPaymentCancellation",
                3050: "GENRL20",
                2256: "com.stillwater_ExtendedVacancy"
              }, this.getAge("01/01/" + t.yearbuilt), a = "03", r = this.getClientId(), e.next = 7, backendService.getAppData(r);
            case 7:
              for (g in i = e.sent, i = (i = JSON.parse(i.Payload)).body, o = i.swQuoteId, s = "<Construction>\n                                \x3c!--<ConstructionCd>".concat(t.propertyDetails.construction_type, "</ConstructionCd>--\x3e\n                                <YearBuilt>").concat(t.yearbuilt, "</YearBuilt>\n                                \x3c!--<NumStories>").concat(t.propertyDetails.stories, "</NumStories>--\x3e\n                                \x3c!--<RoofingMaterial>\n                                <RoofMaterialCd>").concat(t.propertyDetails.roof_type, "</RoofMaterialCd>\n                                </RoofingMaterial>--\x3e\n                                <ElectricalPanelCd>CIRC</ElectricalPanelCd>\n                                </Construction>"), l = "", l = "" != t.propertyDetails.stories ? "<DwellInspectionValuation>\n                                    <NumFamilies>1</NumFamilies>\n                                    <NumStoriesInDwellingCd>".concat(t.propertyDetails.stories, "</NumStoriesInDwellingCd>\n                                    <TotalLivingArea>\n                                        <NumUnits>").concat(t.propertyDetails.living_size, "</NumUnits>\n                                    </TotalLivingArea>\n                                </DwellInspectionValuation>") : "<DwellInspectionValuation>\n                                    <NumFamilies>1</NumFamilies>\n\n                                    <TotalLivingArea>\n                                        <NumUnits>".concat(t.propertyDetails.living_size, "</NumUnits>\n                                    </TotalLivingArea>\n                                </DwellInspectionValuation>"), u = "", t.propertyDetails.roof_constructed && "" != t.propertyDetails.roof_constructed && (u = "<BldgImprovements>\n                                    <RoofingImprovementYear>".concat(t.propertyDetails.roof_constructed, "</RoofingImprovementYear>\n                                </BldgImprovements>")), c = mapper.mapdata(this.id, "stillWater", t), o && "" != o && (c = c.replace("POLICYNUMBER_PLACEHOLDER", "<QuoteInfo>\n                                                            <CompanysQuoteNumber>".concat(o, "</CompanysQuoteNumber>\n                                                        </QuoteInfo>"))), m = "06" == a ? "CD" : "DW", c = (c = (c = (c = (c = (c = c.replace("DEDUCTIBLE_PLACEHOLDER", 500)).replace("POLICYTYPE_PLACEHOLDER", a)).replace("RESIDENCETYPE_PLACEHOLDER", m)).replace("CONSTRUCTION_PLACEHOLDER", s)).replace("BLDGIMPROVEMENTS_PLACEHOLDER", u)).replace("DWELLINSPECTIONVALUATION_PLACEHOLDER", l), p = "", d = ["25", "43"], n) d.includes(g) || (t.swquote_question.includes(parseInt(g)) ? p += mapper.getSWQuestionXML({
                question: n[g],
                answer: "YES"
              }) : p += mapper.getSWQuestionXML({
                question: n[g],
                answer: "NO"
              }));
              return c = c.replace("COVERAGES_PLACEHOLDER", p), c = mapper.cleanSWXML(c), console.log("xmlInputString", c), _ = "", e.next = 34, backendService.getQuotesFromStillWater({
                xmlInputString: c
              }, this.id + "_swQuoteKnockout");
            case 34:
              return y = e.sent, y = (y = JSON.parse(y.Payload)).body.output[0].output, h = convert.xml2json(y, {
                compact: !0,
                spaces: 4
              }), h = JSON.parse(h), w = !1, C = !1, (v = h.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs).hasOwnProperty("MsgStatus") && v.MsgStatus.MsgStatusCd && ("Error" == v.MsgStatus.MsgStatusCd._text || "Rejected" == v.MsgStatus.MsgStatusCd._text) && (_ = v.MsgStatus.MsgStatusDesc._text, w = !0, _.includes("Exception") && (C = !0)), e.abrupt("return", {
                message: _,
                knockout: w,
                hasError: C
              });
            case 44:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return K.apply(this, arguments);
      })
    }, {
      key: "swQuoteDiscountXML",
      value: function (e) {
        e.sw_discounts || (e.sw_discounts = [800, 4250, 4301, 4965, 9099, 4350, 1700, 2e3, 61, 1205]);
        var t = "",
          n = "",
          a = "",
          r = "";
        return e.sw_discounts.includes(4965) && (t += "<PersonInfo><BirthDt>".concat(this.formatDate(e.dob), "</BirthDt>\n                                    <MaritalStatusCd>M</MaritalStatusCd></PersonInfo>")), e.sw_discounts.includes(61) && (n += "<Construction>\n                                <ConstructionCd>F</ConstructionCd>\n                                <YearBuilt>".concat(e.yearbuilt, "</YearBuilt>\n                                <FoundationCd>BS</FoundationCd>\n                                \x3c!--<NumStories>1</NumStories>--\x3e\n                                <RoofingMaterial>\n                                <RoofMaterialCd>ASPHS</RoofMaterialCd>\n                                </RoofingMaterial>\n                                <ElectricalPanelCd>CIRC</ElectricalPanelCd>\n                                <com.stillwater_AccreditedBuilder>\n                                <com.stillwater_BuilderNumber>").concat(e.ca_builder, "</com.stillwater_BuilderNumber>\n                                </com.stillwater_AccreditedBuilder>\n                                </Construction>")), (e.sw_discounts.includes(4200) || e.sw_discounts.includes(4255) || e.sw_discounts.includes(4305)) && (a += "<BldgProtection>"), e.sw_discounts.includes(4200) && (a += "<FireExtinguisherInd>1</FireExtinguisherInd>"), e.sw_discounts.includes(4305) && (a += "<ProtectionDeviceBurglarCd>CN</ProtectionDeviceBurglarCd>"), e.sw_discounts.includes(4255) && (a += "<ProtectionDeviceFireCd>NO</ProtectionDeviceFireCd>"), e.sw_discounts.includes(4200) && (a += "<ProtectionDeviceSmokeCd>NO</ProtectionDeviceSmokeCd>"), e.sw_discounts.includes(4200) && (a += "<DoorLockCd>DEADB</DoorLockCd>"), (e.sw_discounts.includes(4200) || e.sw_discounts.includes(4255) || e.sw_discounts.includes(4305)) && (a += "</BldgProtection>"), e.sw_discounts.includes(9099) && (r += "<QuestionAnswer>\n                    <QuestionCd>HOME24</QuestionCd>\n                    <YesNoCd>YES</YesNoCd>\n                    </QuestionAnswer>"), {
          marriedStatus: t,
          construction: n,
          bldgProtection: a,
          home24: r
        };
      }
    }, {
      key: "swAppKnockoutXML",
      value: function (e) {
        e.sw_appQuestions || (e.sw_appQuestions = ["4pt8", "4pt11", "4pt12", "4pt13", "4pt14", "4pt16", "4pt17", "4pt19", "4pt20", "4pt21", "4pt22", "4pt24"]);
        var t = {
          "4pt8": "",
          "4pt11": "",
          "4pt12": "",
          "4pt13": "",
          "4pt14": "",
          "4pt16": "",
          "4pt17": "",
          "4pt19": "",
          "4pt20": "",
          "4pt21": "",
          "4pt22": "",
          "4pt24": ""
        };
        return e.sw_appQuestions.includes("4pt8") && (t["4pt8"] += mapper.getSWQuestionXML({
          question: "com.stillwater_InspectionNotification",
          answer: "YES"
        })), e.sw_appQuestions.includes("4pt11") && (t["4pt11"] += '<Loss id="LOSS1" LocationRef="LOC1">\n                                <LossCauseCd>Liability</LossCauseCd>\n                                <ClaimStatusCd>C</ClaimStatusCd>\n                                </Loss>', t["4pt11"] += '<Loss id="LOSS2" LocationRef="LOC1">\n                                <LossCauseCd>Water</LossCauseCd>\n                                </Loss>', t["4pt11"] += '<Loss id="LOSS3" LocationRef="LOC1">\n                                <LossCauseCd>Weather</LossCauseCd>\n                                </Loss>', t["4pt11"] += '<Loss id="LOSS4" LocationRef="LOC1">\n                                <LossCauseCd>Weather</LossCauseCd>\n                                </Loss>', t["4pt11"] += '<Loss id="LOSS5" LocationRef="LOC1">\n                                <LossCauseCd>Other</LossCauseCd>\n                                <ClaimStatusCd>C</ClaimStatusCd>\n                                </Loss>'), e.sw_appQuestions.includes("4pt12") && (t["4pt12"] += mapper.getSWQuestionXML({
          question: "GENRL15",
          answer: "YES"
        })), e.sw_appQuestions.includes("4pt13") && (t["4pt13"] += mapper.getSWQuestionXML({
          question: "com.stillwater_UnusualVehicleStorage",
          answer: "NO"
        })), e.sw_appQuestions.includes("4pt14") && (t["4pt14"] += mapper.getSWQuestionXML({
          question: "GENRL31",
          answer: "NO"
        })), e.sw_appQuestions.includes("4pt16") && (t["4pt16"] += "<Construction>\n                                <ConstructionCd>F</ConstructionCd>\n                                <YearBuilt>1950</YearBuilt>\n                                <FoundationCd>BS</FoundationCd>\n                                \x3c!--<NumStories>1</NumStories>--\x3e\n                                <RoofingMaterial>\n                                    <RoofMaterialCd>ASPHS</RoofMaterialCd>\n                                </RoofingMaterial>\n                                <ElectricalPanelCd>CIRC</ElectricalPanelCd>\n                            </Construction>"), e.sw_appQuestions.includes("4pt17") && (t["4pt17"] += mapper.getSWQuestionXML({
          question: "com.stillwater_RoofCondition",
          answer: "YES"
        })), e.sw_appQuestions.includes("4pt19") && (t["4pt19"] += mapper.getSWQuestionXML({
          question: "com.com.stillwater_RoofLess20Year",
          answer: "NO"
        })), e.sw_appQuestions.includes("4pt20") && (t["4pt20"] += "<com.stillwater_SolidFuel>P</com.stillwater_SolidFuel>"), e.sw_appQuestions.includes("4pt21") && (t["4pt21"] += "<com.stillwater_SolidFuel>P</com.stillwater_SolidFuel>"), e.sw_appQuestions.includes("4pt22") && (t["4pt22"] += "<BldgProtection>\n                        <DistanceToFireStation>\n                        <NumUnits>3</NumUnits>\n                        <UnitMeasurementCd>MI</UnitMeasurementCd>\n                        </DistanceToFireStation>\n                        <DistanceToHydrant>\n                        <NumUnits>10000</NumUnits>\n                        <UnitMeasurementCd>FT</UnitMeasurementCd>\n                        </DistanceToHydrant>\n                        <FireExtinguisherInd>1</FireExtinguisherInd>\n                        <ProtectionDeviceBurglarCd>CN</ProtectionDeviceBurglarCd>\n                        <ProtectionDeviceFireCd>CN</ProtectionDeviceFireCd>\n                        <ProtectionDeviceSmokeCd>NO</ProtectionDeviceSmokeCd>\n                        <ProtectionDeviceSprinklerCd>NO</ProtectionDeviceSprinklerCd>\n                        <DoorLockCd>DEADB</DoorLockCd>\n                        </BldgProtection>"), e.sw_appQuestions.includes("4pt24") && (t["4pt24"] += mapper.getSWQuestionXML({
          question: "AGLIA24",
          answer: "NO"
        })), t;
      }
    }, {
      key: "swSaveSelectedPlanType",
      value: (X = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t,
          n,
          a,
          r,
          i = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = i.length > 0 && void 0 !== i[0] ? i[0] : "economy", n = this.getClientId(), e.next = 4, backendService.saveUpdateClientData(n, {
                swQuoteSelectedPlan: t,
                id: n,
                clientId: n,
                uid: n
              });
            case 4:
              return e.next = 6, this.swGetSelectedPlan(t);
            case 6:
              return a = e.sent, r = flatten(a), e.next = 10, backendService.saveUpdateClientData(n, {
                swQuoteCustomizedPlan: r,
                id: n,
                clientId: n,
                uid: n
              });
            case 10:
              return e.abrupt("return", !0);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return X.apply(this, arguments);
      })
    }, {
      key: "swGetSelectedPlan",
      value: (V = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t,
          n,
          a,
          r,
          i = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = i.length > 0 && void 0 !== i[0] ? i[0] : "economy", n = this.getClientId(), e.next = 4, backendService.getAppData(n);
            case 4:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, r = t, a = unflatten(a.swQuotes), console.log("clientData swQuoteSelectedPlan", a["swQuote_" + r]), e.abrupt("return", a["swQuote_" + r]);
            case 11:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return V.apply(this, arguments);
      })
    }, {
      key: "swGetCustomizedPlan",
      value: (z = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t,
          n,
          a,
          r = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = r.length > 0 && void 0 !== r[0] ? r[0] : "customize", n = this.getClientId(), e.next = 4, backendService.getAppData(n);
            case 4:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, a = "customize" == t ? unflatten(a.swQuoteCustomizedPlan) : (a = unflatten(a.swQuotes))["swQuote_" + t], console.log("clientData 3 :", a), e.abrupt("return", a);
            case 10:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return z.apply(this, arguments);
      })
    }, {
      key: "getDynamoDBData",
      value: ($ = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, backendService.getAppData(t);
            case 2:
              return n = e.sent, n = JSON.parse(n.Payload), console.log("clientData 2 :", n), n = n.body, e.abrupt("return", n);
            case 7:
            case "end":
              return e.stop();
          }
        }, e);
      })), function (e) {
        return $.apply(this, arguments);
      })
    }, {
      key: "getQuickQuote",
      value: (J = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i, o, s, l, u, c, m, p, d, g;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = [], a = mapper.mapdata(this.id, "stillWater", t), r = this.getUid(t, stillwaterUidKey), i = mapper.mapdata(this.id, "paclife", t), o = this.getUid(i, packlifeUidKey), mapper.mapdata(this.id, "symetra", t), s = mapper.mapdata(this.id, "SBLI", t), l = this.getUid(s, sbliUidKey), e.next = 10, backendService.getQuotesFromStillWater({
                xmlInputString: a
              }, r);
            case 10:
              return u = e.sent, e.next = 13, backendService.getQuotesFromSBLIAfficiency(s, l);
            case 13:
              return c = e.sent, e.next = 16, backendService.getQuotesFromPaclife(i, o);
            case 16:
              return m = e.sent, p = this.getStillWaterAmount(u), d = this.getPaclifeAmount(m), g = this.getSBLIAmount(c), n = [{
                head: {
                  category_name: "Fast",
                  icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/ic-fast-logo.svg",
                  text1: "90% in your age group chose this plan.",
                  text1_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/ic-fast-social-icon.svg",
                  text2: "Immediate online bind"
                },
                body: {
                  section1: {
                    text1: "Total Cost Per Month",
                    text2: "$" + totalFast.toFixed(2)
                  },
                  section2: [{
                    carrier_name: "Next Term Life",
                    quote_amount: d,
                    carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/paclife-logo.png"
                  }, {
                    carrier_name: "Stillwater Home Insurance",
                    quote_amount: p,
                    carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/stillwater-logo.png"
                  }]
                }
              }, {
                head: {
                  category_name: "Flexi",
                  icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/ic-flexi-logo.svg",
                  text1: "55% in your location chose this plan.",
                  text1_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/ic-flexi-social.svg",
                  text2: "Allows addition of various life events"
                },
                body: {
                  section1: {
                    text1: "Total Cost Per Month",
                    text2: "$" + totalFlexi.toFixed(2)
                  },
                  section2: [{
                    carrier_name: "SBLI Term",
                    quote_amount: g,
                    carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/sbli-logo-vfd737.svg"
                  }, {
                    carrier_name: "Stillwater Home Insurance",
                    quote_amount: p,
                    carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/stillwater-logo.png"
                  }]
                }
              }, {
                head: {
                  category_name: "Affordable",
                  icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/ic-affordable-icon.svg",
                  text1: "60% in your age group chose this plan.",
                  text1_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/ic-affordable-social.svg",
                  text2: "Lowest pricing in your area"
                },
                body: {
                  section1: {
                    text1: "Total Cost Per Month",
                    text2: "$" + (totalAffordable + 31).toFixed(2)
                  },
                  section2: [{
                    carrier_name: "Principal Total",
                    quote_amount: "$31",
                    carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/principal-logo.png"
                  }, {
                    carrier_name: "Stillwater Home Insurance",
                    quote_amount: p,
                    carrier_icon: "https://public-bubble.s3-us-west-2.amazonaws.com/images/images/stillwater-logo.png"
                  }]
                }
              }], e.abrupt("return", n);
            case 22:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return J.apply(this, arguments);
      })
    }, {
      key: "getPaclifeAmount",
      value: function (e) {
        var t = "0",
          n = "0";
        return e && (t = e.premiumAmount, n = e.premiumAmountA), !e.code || 500 != e.code && 504 != e.code || (paclifeError = !0), totalFast += +t, {
          paclifeAmount: t = t ? "$".concat(t) : "0",
          paclifeannualAmount: n = "$".concat(n)
        };
      }
    }, {
      key: "getStillWaterAmount",
      value: function (e, t) {
        var n = "0",
          a = "0",
          r = [],
          i = "";
        e = (e = JSON.parse(e.Payload)).body.output[0].output, console.log("stillwater output xml: ", e);
        var o = convert.xml2json(e, {
            compact: !0,
            spaces: 4
          }),
          s = (o = JSON.parse(o)).ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs;
        if (s.hasOwnProperty("MsgStatus") && "Error" == s.MsgStatus.MsgStatusCd._text) i = s.MsgStatus.MsgStatusDesc._text;else if (s.hasOwnProperty("HomeLineBusiness")) {
          if (r = s.HomeLineBusiness.Dwell.Coverage, s.PersPolicy.PaymentOption && s.PersPolicy.PaymentOption[0].DepositAmt.Amt._text) {
            n = s.PersPolicy.PaymentOption[0].DepositAmt.Amt._text;
            var l = s.HomeLineBusiness.Dwell.Coverage;
            a = (a = l.filter(function (e) {
              return "DWELL" == e.CoverageCd._text;
            }))[0].Limit.FormatInteger._text, a = parseInt(t);
          }
        } else n = "0";
        return "0" == (n = n || "0") && (swError = !0), {
          quote: n = "$".concat(n),
          dwellAmt: "$".concat(a),
          coverages: r,
          errorMessage: i,
          swResponseJson: o
        };
      }
    }, {
      key: "getSBLIAmount",
      value: function (e) {
        var t = "0";
        return (e = JSON.parse(e.Payload)).body && e.body.output && (t = e.body.output[0]["output.monthlyQuote"]), "0" == (t = t || "0") && (sbliError = !0), totalFlexi += +t, t = "$".concat(t);
      }
    }, {
      key: "getSWPaymentOptions",
      value: (Q = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g = this;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.swGetCustomizedPlan();
            case 2:
              n = e.sent, console.log(n), a = n.swResponseJson, r = ["com.stillwater_DB01"], i = ["com.stillwater_DB03", "com.stillwater_EF12", "com.stillwater_CC70", "com.stillwater_DB15", "com.stillwater_DB16", "com.stillwater_DB04"], o = [], s = [], l = a.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.PaymentOption, console.log("Paymentoptions", JSON.stringify(l)), u = "", c = _regeneratorRuntime.mark(function e(t) {
                return _regeneratorRuntime.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      u = "", (u = l.filter(function (e) {
                        return e.PaymentPlanCd._text == r[t];
                      })[0]) && o.push({
                        payType: u.PaymentPlanCd._text,
                        paymentPlan: u.PaymentPlanDesc._text,
                        numPayments: u.NumPayments._text,
                        numInstallments: u.NumInstallments._text,
                        totalPremium: g.numberWithCommas(u.TotalPremium._text),
                        installmentFeeAmt: g.numberWithCommas(u.InstallmentFeeAmt.Amt._text),
                        installmentPay: g.numberWithCommas(u.DepositAmt.Amt._text),
                        installmentInfo: u.InstallmentInfo ? u.InstallmentInfo : null
                      });
                    case 3:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }), m = 0;
            case 14:
              if (!(m < r.length)) {
                e.next = 19;
                break;
              }
              return e.delegateYield(c(m), "t0", 16);
            case 16:
              m++, e.next = 14;
              break;
            case 19:
              p = _regeneratorRuntime.mark(function e(t) {
                return _regeneratorRuntime.wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      u = "", (u = l.filter(function (e) {
                        return e.PaymentPlanCd._text == i[t];
                      })[0]) && ("com.stillwater_CC70" == u.PaymentPlanCd._text && (u.PaymentPlanDesc._text = "Monthly - Debit/Credit Card billed monthly"), s.push({
                        payType: u.PaymentPlanCd._text,
                        paymentPlan: u.PaymentPlanDesc._text,
                        numPayments: u.NumPayments._text,
                        numInstallments: u.NumInstallments._text,
                        totalPremium: g.numberWithCommas(u.TotalPremium._text),
                        installmentFeeAmt: g.numberWithCommas(u.InstallmentFeeAmt.Amt._text),
                        installmentPay: g.numberWithCommas(u.DepositAmt.Amt._text),
                        installmentInfo: u.InstallmentInfo
                      }));
                    case 3:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }), d = 0;
            case 21:
              if (!(d < i.length)) {
                e.next = 26;
                break;
              }
              return e.delegateYield(p(d), "t1", 23);
            case 23:
              d++, e.next = 21;
              break;
            case 26:
              return console.log(o), console.log(s), e.abrupt("return", {
                fullPayDetails: o,
                schedulePayDetails: s
              });
            case 29:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return Q.apply(this, arguments);
      })
    }, {
      key: "getSbliInput",
      value: function (e) {
        return {
          arcId: null,
          quoteRateClassRequest: 10,
          distributorId: 8444,
          productId: "dwellingcost5-Lambda-SCOMW3US0YHS" == CriticalInput.ESTIMATOR_WHATIFS_API1_LAMBDA ? 81410 : 8141,
          gender: e.gender,
          dob: e.dob,
          term: e.term,
          zip: e.zip,
          state: e.state,
          height: e.height,
          weight: e.weight,
          healthStatusRank: 1,
          tobaccoUse: e.tobaccoUse,
          coverage: e.coverage,
          benefitLength: 1,
          referenceURL: "htpp://www.affigee.com",
          channel: "commercial",
          campaignCode: 1,
          affiliateCode: 1,
          deviceId: "Id12345",
          deviceType: "laptop",
          cookieId: 1,
          browserVersion: 77,
          browserName: "chrome",
          ipAddress: "123.23.2.232"
        };
      }
    }, {
      key: "getSbliUid",
      value: function (e) {
        for (var t = ["quoteRateClassRequest", "distributorId", "productId", "gender", "dob", "term", "zip", "state", "height", "weight", "healthStatusRank", "tobaccoUse", "coverage", "benefitLength", "channel", "ipAddress"], n = [], a = 0; a < t.length; a += 1) {
          var r = e[t[a]];
          r = Array.isArray(r) ? r.join("~").replace(/ /g, "") : r.toString().replace(/\./g, "DOT").replace(/ /g, ""), n.push(r);
        }
        return n.join(".");
      }
    }, {
      key: "getPaclifeUid",
      value: function (e) {
        for (var t = ["faceAmount", "dob", "riskClass", "premiumFrequency", "state", "gender", "productCode", "smoker"], n = [], a = 0; a < t.length; a += 1) {
          var r = e[t[a]];
          r = Array.isArray(r) ? r.join("~").replace(/ /g, "") : r.toString().replace(/\./g, "DOT").replace(/ /g, ""), n.push(r);
        }
        return n.join(".");
      }
    }, {
      key: "getUid",
      value: function (e, t) {
        for (var n = t, a = [], r = 0; r < n.length; r += 1) {
          var i = e[n[r]];
          i = Array.isArray(i) ? i.join("~").replace(/ /g, "") : i.toString().replace(/\./g, "DOT").replace(/ /g, ""), a.push(i);
        }
        return a.join(".");
      }
    }, {
      key: "getCarrierRules",
      value: function (e) {
        return {
          paclife: {
            coverage: {
              min: 25e4,
              max: 1e7
            }
          },
          sbli: {
            coverage: {
              min: 25e3,
              max: {
                age: [{
                  max: 50,
                  min: 18,
                  value: 1e6
                }, {
                  max: 51,
                  min: 65,
                  value: 5e5
                }]
              }
            }
          }
        }[e];
      }
    }, {
      key: "getAge",
      value: function (e) {
        var t = new Date(),
          n = new Date(e);
        n.getMonth(), n.getDate(), n.getFullYear();
        return t.getFullYear() - n.getFullYear();
      }
    }, {
      key: "formatDate",
      value: function (e) {
        var t = new Date(e),
          n = "" + (t.getMonth() + 1),
          a = "" + t.getDate(),
          r = t.getFullYear();
        return n.length < 2 && (n = "0" + n), a.length < 2 && (a = "0" + a), [r, n, a].join("-");
      }
    }, {
      key: "getSWPreBindData",
      value: (U = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i, o, s, l;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.swGetCustomizedPlan();
            case 2:
              return n = e.sent, a = n.swResponseJson, r = a.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.QuoteInfo.CompanysQuoteNumber._text, i = new StillWaterHelper.StillWaterHelper(), e.next = 8, utilityModule.getClientId();
            case 8:
              return e.sent, o = this.getClientId(), l = [], e.next = 13, i.swPrebind(t, r, o).then(function (e) {
                s = e, console.log("prebindData:", JSON.stringify(s));
                var t = s.swOutput.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs;
                s = s.swOutput.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PolicySummaryInfo["com.stillwater_AcknowledgementStatement"];
                var n = "",
                  a = "";
                if (t.hasOwnProperty("MsgStatus") && (console.log("if one"), n = t.MsgStatus.MsgStatusCd._text, console.log("if one errorStatus", n), t.MsgStatus.hasOwnProperty("MsgStatusDesc") && (a = t.MsgStatus.MsgStatusDesc._text), console.log("if one errorMessage", a)), "Rejected" == n) l.push({
                  statementId: "",
                  statementText: "",
                  statementDocument: "",
                  errorMessage: a,
                  errorStatus: n
                }), console.log("if two", l);else if (s.length > 0) for (var r = 0; r < s.length; r++) l.push({
                  statementId: s[r]["com.stillwater_StatementId"] ? s[r]["com.stillwater_StatementId"]._text : null,
                  statementText: s[r]["com.stillwater_StatementText"] ? s[r]["com.stillwater_StatementText"]._text : null,
                  statementDocument: s[r]["com.stillwater_StatementDocument"] ? s[r]["com.stillwater_StatementDocument"]._text : null,
                  errorMessage: a,
                  errorStatus: n
                });else l.push({
                  statementId: s["com.stillwater_StatementId"] ? s["com.stillwater_StatementId"]._text : null,
                  statementText: s["com.stillwater_StatementText"] ? s["com.stillwater_StatementText"]._text : null,
                  statementDocument: s["com.stillwater_StatementDocument"] ? s["com.stillwater_StatementDocument"]._text : null,
                  errorMessage: a,
                  errorStatus: n
                });
                console.log("-------", l);
              }).catch(function (e) {
                return console.log("getSWPreBindData lib Error:", e), e;
              });
            case 13:
              return console.log("returned"), e.abrupt("return", l);
            case 15:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return U.apply(this, arguments);
      })
    }, {
      key: "submitSWPaymentDetails",
      value: (q = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g,
          _,
          y,
          h,
          w,
          C,
          v = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = v.length > 1 && void 0 !== v[1] ? v[1] : {}, e.next = 3, this.swGetCustomizedPlan();
            case 3:
              return a = e.sent, r = a.swResponseJson, i = r.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.QuoteInfo.CompanysQuoteNumber._text, o = this.getClientId(), e.next = 9, backendService.getAppData(o);
            case 9:
              return s = e.sent, s = (s = JSON.parse(s.Payload)).body, l = unflatten(s.stillwater), console.log("appJson", JSON.stringify(l)), e.next = 16, utilityModule.getClientId();
            case 16:
              return e.sent, u = new StillWaterHelper.StillWaterHelper(), e.next = 20, u.swBindPayment(t, i, l, o, this.getSWLenderOptions(), n);
            case 20:
              return c = e.sent, m = c.swOutput, console.log(m), console.log(JSON.stringify(m)), p = flatten(m), e.next = 27, backendService.saveUpdateClientData(o, {
                swPolicyBind: p,
                id: o,
                clientId: o,
                uid: o
              });
            case 27:
              return d = !1, g = {}, m.ACORD.InsuranceSvcRs.HomePolicyAddRs ? (_ = m.ACORD.InsuranceSvcRs.HomePolicyAddRs, y = "", h = "", w = "", C = "", "Success" == _.MsgStatus.MsgStatusCd._text ? (_ = _.PolicySummaryInfo, console.log("SW Policy docs", _), (y = _["com.stillwater_PolicyDocument"].filter(function (e) {
                return "DecPage" == e["com.stillwater_DocID"]._text;
              })) && (y = y[0] ? y[0]["com.stillwater_DocumentUrl"]._text : ""), (h = _["com.stillwater_PolicyDocument"].filter(function (e) {
                return "AcordApp" == e["com.stillwater_DocID"]._text;
              })) && (h = h[0] ? h[0]["com.stillwater_DocumentUrl"]._text : ""), (w = _["com.stillwater_PolicyDocument"].filter(function (e) {
                return "PolicyConfirm" == e["com.stillwater_DocID"]._text;
              })) && (w = w[0] ? w[0]["com.stillwater_DocumentUrl"]._text : ""), (C = _["com.stillwater_PolicyDocument"].filter(function (e) {
                return "Emailed Homeowners Valuation" == e["com.stillwater_DocID"]._text;
              })) && (C = C[0] ? C[0]["com.stillwater_DocumentUrl"]._text : ""), g = {
                insuredId: _.ItemIdInfo.InsurerId._text,
                policyNumber: _.PolicyNumber._text,
                decPage_url: y,
                acordApp_url: h,
                policyConfirm_url: w,
                emailDoc_url: C,
                accountSetup_url: _["com.stillwater_AccountSetupUrl"]._text
              }) : d = !0) : d = !0, console.log("Payment output", g), e.abrupt("return", {
                hasError: d,
                data: g
              });
            case 32:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return q.apply(this, arguments);
      })
    }, {
      key: "getSWCustomizeValues",
      value: (G = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t,
          n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g,
          _,
          y,
          h,
          w,
          C,
          v,
          S,
          b,
          A,
          x,
          f,
          P,
          I,
          T,
          O,
          N,
          R,
          k,
          H,
          D,
          W,
          L,
          F,
          M,
          E,
          B,
          G,
          q,
          U,
          Q,
          J,
          $,
          z = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = z.length > 0 && void 0 !== z[0] ? z[0] : "m", n = z.length > 1 && void 0 !== z[1] ? z[1] : "customize", a = !(z.length > 2 && void 0 !== z[2]) || z[2], e.next = 5, this.swGetCustomizedPlan(n);
            case 5:
              for (r = e.sent, console.log("customizedPlan_1", r), i = r.commonCoverages, o = r.swResponseJson, console.log("swPlan_1", o), console.log("All coverages from stillwater: ", o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.HomeLineBusiness.Dwell.Coverage), console.log("commonCoverages", i), console.log("Discounts_1", o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy), s = [], o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.hasOwnProperty("com") && o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.com.hasOwnProperty("stillwater_QuoteProposalDiscount") && (s = o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.com.stillwater_QuoteProposalDiscount, console.log("discounts_02", s)), l = new StillWaterHelper.StillWaterHelper(), u = o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.HomeLineBusiness.Dwell.Coverage, c = [], m = u.filter(function (e) {
                return "SPP" == e.CoverageCd._text;
              }), console.log("spps", m), p = "", d = 0; d < m.length; d++) p = m[d].CurrentTermAmt ? "$" + l.getMonthlyPremiums(m[d].CurrentTermAmt.Amt._text, t) : "Included", c.push({
                sppName: m[d].CoverageDesc._text,
                sppPremium: p
              });
              if (console.log("SPP", c), g = "", _ = {}, y = i.state, h = i.homeType, i.planType, w = {
                deductible: {},
                dwelling: {},
                other_structure: {},
                personal_property: {},
                loss_of_use: {},
                liability: {},
                medical_payment: {},
                acc_rc: {},
                inflation_guard: {},
                building_ordinance: {},
                common_construction: {},
                extended_replacement: {},
                animal_liability: {},
                mold: {},
                moldi: {},
                identity_recovery: {},
                mineSubsidence: {}
              }, C = {
                wind_hail: {},
                hurricane: {},
                hurricane_premium: {},
                earthquake: {},
                water_backup: {},
                home_cyberbase: {},
                hcbpackage_databreach: {},
                hcbbreach_bullying: {},
                homesys_protect: {},
                identity_protection: {},
                serviceline: {},
                loss_asessment: {},
                business_property: {},
                personal_injury: {},
                spp: {},
                water_damage: {}
              }, v = [], S = [], b = [], Array.isArray(s)) for (A = 0; A < s.length; A++) v.push(s[A]._text);else v.push(s._text);
              for (x in console.log("discountApplied_1", v), console.log("swCoverages_000002", u), u) {
                if (g = "", _[u[x].CoverageCd._text] = {}, g = "CoverageCD: " + u[x].CoverageCd._text, u[x].Limit && (g += ", Limit: " + u[x].Limit.FormatInteger._text, _[u[x].CoverageCd._text].limit = u[x].Limit.FormatInteger._text), u[x].CurrentTermAmt && (g += ", CurrentTermAmt: " + u[x].CurrentTermAmt.Amt._text, _[u[x].CoverageCd._text].CurrentTermAmt = u[x].CurrentTermAmt.Amt._text), "CO" == y && "06" != h && "LOU" == u[x].CoverageCd._text && (console.log(), _[u[x].CoverageCd._text].CurrentTermAmt = u[x].Option.OptionValueDesc._text), "06" == h && "PP" == u[x].CoverageCd._text && (S = null === (f = u[x]) || void 0 === f ? void 0 : f.Deductible, console.log("otherDeductibles", S), S.length > 0)) for (P = 0; P < S.length; P++) g += ", " + S[P].DeductibleAppliesToCd._text, b.push(S[P].DeductibleAppliesToCd._text);
                if ("06" != h && "DWELL" == u[x].CoverageCd._text && (S = null === (I = u[x]) || void 0 === I ? void 0 : I.Deductible, console.log("otherDeductibles", S), S.length > 0)) for (T = 0; T < S.length; T++) g += ", " + S[T].DeductibleAppliesToCd._text, "WindHail" == S[T].DeductibleAppliesToCd._text && "OH" != i.state ? (i.wind_hail = (null === (O = S[T].FormatPct) || void 0 === O ? void 0 : O._text) + "%" || S[T].FormatInteger._text, b.push(S[T].DeductibleAppliesToCd._text)) : ("HURR" == S[T].DeductibleAppliesToCd._text && "FL" == i.state && (i.hurricane = (null === (N = S[T].FormatPct) || void 0 === N ? void 0 : N._text) + "%" || S[T].FormatInteger._text, console.log("hurricanehurricane", i.hurricane)), b.push(S[T].DeductibleAppliesToCd._text));
                console.log("ct_01", g);
              }
              if (console.log("coverageJsonSW_001", _), w.deductible = {
                title: "Policy Deductible",
                help_text: l.getSWToolTips("deductible").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("deductible", i),
                premium: "",
                answer_key: "deductible"
              }, R = o.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs.PersPolicy.PaymentOption.filter(function (e) {
                return "com.stillwater_EF12" == e.PaymentPlanCd._text;
              })[0], k = R.TotalPremium._text, H = Number(R.TotalPremium._text.replace(/[^0-9.-]+/g, "")), console.log("newMonthlyPremium", H), H = (H / 12).toFixed(2), console.log("newMonthlyPremium", H), H = "$" + this.numberWithCommas(H) + "/month", k = "$" + this.numberWithCommas(k) + "/year", console.log("yearlyPremium", k), R = R.InstallmentInfo[0].InstallmentAmount._text, w.dwelling = {
                title: "Dwelling Coverage",
                help_text: l.getSWToolTips("dwelling").text,
                input_type: "text",
                input_editable: !0,
                input_value: i.final_dwell,
                premium: "$" + l.getMonthlyPremiums(_.DWELL.CurrentTermAmt, t),
                answer_key: "dwelling"
              }, "06" != h && (w.other_structure = "FL" == y ? {
                title: "Other Structures",
                help_text: l.getSWToolTips("other_structure").text,
                input_type: "dropdown",
                input_editable: !1,
                dropdown_values: l.getCustomizeOptions("other_structure", i),
                premium: _.OS && _.OS.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.OS.CurrentTermAmt, t) : "Included",
                answer_key: "other_structure"
              } : {
                title: "Other Structures",
                help_text: l.getSWToolTips("other_structure").text,
                input_type: "text",
                input_editable: !1,
                input_value: _.OS.limit,
                premium: "Included",
                answer_key: "other_structure"
              }), D = 0, W = 0, _.RCC && _.RCC.CurrentTermAmt && (D = _.RCC.CurrentTermAmt), _.ACV && _.ACV.CurrentTermAmt && (D = _.ACV.CurrentTermAmt), _.PP && _.PP.CurrentTermAmt && (W = _.PP.CurrentTermAmt), L = 0 != (L = +W + +D) ? "$" + l.getMonthlyPremiums(L.toFixed(2), t) : "Included", console.log("PP_01", W), w.personal_property = {
                title: "Personal Property",
                help_text: l.getSWToolTips("personal_property").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("personal_property", i),
                premium: L,
                answer_key: "personal_property"
              }, w.loss_of_use = "CO" == y ? {
                title: "Loss of Use",
                help_text: l.getSWToolTips("loss_of_use").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _.LOU.CurrentTermAmt,
                answer_key: "loss_of_use"
              } : "FL" == y ? {
                title: "Loss of Use",
                help_text: l.getSWToolTips("loss_of_use").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _.LOU && _.LOU.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.LOU.CurrentTermAmt, t) : "Included",
                answer_key: "loss_of_use"
              } : {
                title: "Loss of Use",
                help_text: l.getSWToolTips("loss_of_use").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("loss_of_use", i),
                premium: _.LOU && _.LOU.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.LOU.CurrentTermAmt, t) : "Included",
                answer_key: "loss_of_use"
              }, w.liability = {
                title: "Liability",
                help_text: l.getSWToolTips("liability").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("liability", i),
                premium: _.PL && _.PL.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.PL.CurrentTermAmt, t) : "Included",
                answer_key: "liability"
              }, w.medical_payment = {
                title: "Medical Payment",
                help_text: l.getSWToolTips("medical_payment").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("medical_payment", i),
                premium: _.MEDPM && _.MEDPM.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.MEDPM.CurrentTermAmt, t) : "Included",
                answer_key: "medical_payment"
              }, "CA" == y && (w.inflation_guard = {
                title: "Inflation Guard",
                help_text: l.getSWToolTips("inflation_guard").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "inflation_guard"
              }), "AZ" != y && "NJ" != y && "NC" != y && "CO" != y && "OH" != y && "PA" != y && "OR" != y && "IN" != y && "WI" != y && "ID" != y && "NV" != y || (_.INFGD && _.INFGD.CurrentTermAmt && "NC" !== y && (i.inflation_guard = 5), w.inflation_guard = {
                title: "Inflation Guard",
                help_text: l.getSWToolTips("inflation_guard").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("inflation_guard", i),
                premium: _.INFGD && _.INFGD.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.INFGD.CurrentTermAmt, t) : "",
                answer_key: "inflation_guard"
              }), "WA" != y && "FL" != y && "TX" != y && "KY" != y || (_.INFGD && _.INFGD.CurrentTermAmt && (i.inflation_guard = 5), C.inflation_guard = {
                title: "Inflation Guard",
                help_text: l.getSWToolTips("inflation_guard").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("inflation_guard", i),
                premium: _.INFGD && _.INFGD.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.INFGD.CurrentTermAmt, t) : "Not Covered",
                answer_key: "inflation_guard"
              }), F = "BldngLaw25%", M = "Included", _["BldngLaw25%"] ? (F = "BldngLaw25%", i.building_ordinance = 25, M = _[F] && _[F].CurrentTermAmt ? "$" + l.getMonthlyPremiums(_[F].CurrentTermAmt, t) : "") : _["BldngLaw50%"] ? (F = "BldngLaw50%", i.building_ordinance = 50, M = _[F] && _[F].CurrentTermAmt ? "$" + l.getMonthlyPremiums(_[F].CurrentTermAmt, t) : "") : _["BldngLaw10%"] ? (F = "BldngLaw10%", i.building_ordinance = 10, M = "") : (i.building_ordinance = null, M = ""), "FL" == y ? w.building_ordinance = {
                title: "Building Ordinance & Law",
                help_text: l.getSWToolTips("building_ordinance").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: M,
                answer_key: "building_ordinance"
              } : "TX" == y ? C.building_ordinance = {
                title: "Building Ordinance & Law",
                help_text: l.getSWToolTips("building_ordinance").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: M,
                answer_key: "building_ordinance"
              } : w.building_ordinance = {
                title: "Building Ordinance & Law",
                help_text: l.getSWToolTips("building_ordinance").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("building_ordinance", i),
                premium: M,
                answer_key: "building_ordinance"
              }, "TX" != y && "WA" != y && "FL" != y && "KY" == !y && (w.common_construction = {
                title: "Common Construction",
                help_text: l.getSWToolTips("common_construction").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "common_construction"
              }), "OH" != y && "KY" != y || (w.common_construction = {
                title: "Common Construction",
                help_text: l.getSWToolTips("common_construction").text,
                input_type: "checkbox",
                input_editable: !1,
                input_value: "Include Coverage",
                checked: !!_.FunctionalReplCost,
                premium: _.FunctionalReplCost && _.FunctionalReplCost.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.FunctionalReplCost.CurrentTermAmt, t) : "Not Covered",
                answer_key: "common_construction"
              }), E = "CovgAExtend25%", "50" == i.extended_replacement ? E = "CovgAExtend50%" : null == i.extended_replacement && (E = null), w.extended_replacement = "FL" == y ? {
                title: "Extended Replacement Cost",
                help_text: l.getSWToolTips("extended_replacement").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _[E] && _[E].CurrentTermAmt ? "$" + l.getMonthlyPremiums(_[E].CurrentTermAmt, t) : "Included",
                answer_key: "extended_replacement"
              } : {
                title: "Extended Replacement Cost",
                help_text: l.getSWToolTips("extended_replacement").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("extended_replacement", i),
                premium: _[E] && _[E].CurrentTermAmt ? "$" + l.getMonthlyPremiums(_[E].CurrentTermAmt, t) : "",
                answer_key: "extended_replacement"
              }, "CA" != y && "WA" != y && "OH" != y || (B = "Included", "WA" != y && "OH" != y || (B = _.AnimalLiability && _.AnimalLiability.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.AnimalLiability.CurrentTermAmt, t) : "Included"), w.animal_liability = {
                title: "Animal Liability",
                help_text: l.getSWToolTips("animal_liability").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: B,
                answer_key: "animal_liability"
              }), "TX" != y && "CO" != y && "IN" != y && "WI" != y && "KY" != y && "ID" != y && "NV" != y || (C.animal_liability = {
                title: "Animal Liability",
                help_text: l.getSWToolTips("animal_liability").text,
                input_type: "checkbox",
                input_editable: !0,
                input_value: "Include Coverage",
                checked: !!_.AnimalLiability,
                premium: _.AnimalLiability && _.AnimalLiability.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.AnimalLiability.CurrentTermAmt, t) : "Not Covered",
                answer_key: "animal_liability"
              }), "AZ" != y && "WA" != y && "CO" != y && "OH" != y && "FL" != y && "PA" != y && "OR" != y && "IN" != y && "WI" != y && "KY" != y && "SC" != y && "ID" != y && "NV" != y || (w.mold = {
                title: "Mold, Fungus, Rot Damage",
                help_text: l.getSWToolTips("mold_fungus").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "mold_fungus"
              }), "NJ" == y && (w.moldi = {
                title: "Limited Mold, Fungus & Rot ",
                help_text: l.getSWToolTips("mold_fungus").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "mold_fungus"
              }), "TX" != y && "WA" != y && "CO" != y && "OH" != y && "VA" != y && "PA" != y && "WI" != y || (w.roof_Damage_WindHail = {
                title: "Roof Damage - Wind/Hail",
                help_text: l.getSWToolTips("roof_Damage_WindHail").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("roof_Damage_WindHail", i),
                premium: _.ACVRoofWindHail && _.ACVRoofWindHail.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.ACVRoofWindHail.CurrentTermAmt, t) : "",
                answer_key: "roof_Damage_WindHail"
              }), "OH" != y && "FL" != y && "IN" != y || (_.MineSubsidence && (w.mineSubsidence = {
                title: "Mine Subsidence ",
                help_text: l.getSWToolTips("mineSubsidence").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "mineSubsidence"
              }), _.identity_recovery && (w.identity_recovery = {
                title: "Identity Recovery ",
                help_text: l.getSWToolTips("identity_recovery").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "identity_recovery"
              })), "FL" != y && "PA" != y || _.SINK && (w.sinkHole = {
                title: "Sink Hole ",
                help_text: l.getSWToolTips("sinkHole").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _.SINK && _.SINK.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.SINK.CurrentTermAmt, t) : "",
                answer_key: "sinkHole"
              }), C.water_backup = "FL" == y ? {
                title: "Water and Sewer Backup",
                help_text: l.getSWToolTips("water_backup").text,
                input_type: "checkbox",
                input_editable: !0,
                input_value: "Include Coverage",
                checked: !!_.SEWER,
                premium: _.SEWER && _.SEWER.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.SEWER.CurrentTermAmt, t) : "Not Covered",
                answer_key: "water_backup"
              } : {
                title: "Water and Sewer Backup",
                help_text: l.getSWToolTips("water_backup").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("water_backup", i),
                premium: _.SEWER && _.SEWER.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.SEWER.CurrentTermAmt, t) : "Not Covered",
                answer_key: "water_backup"
              }, "AZ" != y && "CA" != y && "NJ" != y && "VA" != y && "TX" != y && "CO" != y && "OH" != y && "FL" != y && "PA" != y && "OR" != y && "IN" != y && "WI" != y && "SC" != y && "KY" != y && "ID" != y && "NV" != y || (C.home_cyberbase = {
                title: "Home Cyber Base Package",
                help_text: l.getSWToolTips("home_cyberbase").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("home_cyberbase", i),
                premium: _.HomeCyber && _.HomeCyber.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.HomeCyber.CurrentTermAmt, t) : "Not Covered",
                answer_key: "home_cyberbase"
              }, C.hcbpackage_databreach = {
                title: "Home Cyber Base Package + Data Breach",
                help_text: l.getSWToolTips("hcbpackage_databreach").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("hcbpackage_databreach", i),
                premium: _.HomeCyberBreach && _.HomeCyberBreach.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.HomeCyberBreach.CurrentTermAmt, t) : "Not Covered",
                answer_key: "hcbpackage_databreach"
              }, C.hcbbreach_bullying = {
                title: "Home Cyber Base Package + Data Breach + Cyber Bullying",
                help_text: l.getSWToolTips("hcbbreach_bullying").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("hcbbreach_bullying", i),
                premium: _.HomeCyberBreachBully && _.HomeCyberBreachBully.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.HomeCyberBreachBully.CurrentTermAmt, t) : "Not Covered",
                answer_key: "hcbbreach_bullying"
              }, C.homesys_protect = {
                title: "Home Systems Protection",
                help_text: l.getSWToolTips("homesys_protect").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("homesys_protect", i),
                premium: _.HomeSystems && _.HomeSystems.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.HomeSystems.CurrentTermAmt, t) : "Not Covered",
                answer_key: "homesys_protect"
              }, C.serviceline = {
                title: "Service Line Coverage",
                help_text: l.getSWToolTips("serviceline").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("serviceline", i),
                premium: _.ServiceLine && _.ServiceLine.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.ServiceLine.CurrentTermAmt, t) : "Not Covered",
                answer_key: "serviceline"
              }), G = "Not Covered", q = "FRAUD", _.FRAUD && (G = _.FRAUD.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.FRAUD.CurrentTermAmt, t) : "", q = "FRAUD"), _.IdentityRecovery && (G = _.IdentityRecovery.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.IdentityRecovery.CurrentTermAmt, t) : "", q = "IdentityRecovery"), "CA" != y && "MA" != y && "NC" != y && "WA" != y && "PA" != y && "OR" != y && "IN" != y && "WI" != y || (C.identity_protection = {
                title: "Identity Theft",
                help_text: l.getSWToolTips("identity_protection").text,
                input_type: "dropdown",
                input_editable: "FRAUD" == q,
                dropdown_values: l.getCustomizeOptions("identity_protection", i),
                premium: G,
                answer_key: "identity_protection"
              }), "AZ" != y && "NJ" != y || (w.identity_protection = {
                title: "Identity Theft",
                help_text: l.getSWToolTips("identity_protection").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Not Covered" == G ? "Included" : G,
                answer_key: "identity_protection"
              }), C.spp = {
                title: "Special Personal Property",
                help_text: l.getSWToolTips("spp").text,
                input_type: "checkbox",
                input_editable: !0,
                input_value: "Include Coverage",
                checked: !!_.SPPP,
                premium: _.SPPP && _.SPPP.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.SPPP.CurrentTermAmt, t) : "Not Covered",
                answer_key: "spp"
              }, console.log("SPPPSPPPSPPPSPPP", _.SPPP), "AZ" != y && "CA" != y && "NC" != y && "WA" != y && "CO" != y && "TX" != y && "OH" != y && "FL" != y && "OR" != y && "PA" != y && "IN" != y && "WI" != y && "KY" != y && "SC" != y && "ID" != y && "NV" != y || (C.loss_asessment = {
                title: "Loss Assessment",
                help_text: l.getSWToolTips("loss_asessment").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("loss_asessment", i),
                premium: _.LAC && _.LAC.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.LAC.CurrentTermAmt, t) : "Not Covered",
                answer_key: "loss_asessment"
              }), "CA" == y && (C.business_property = {
                title: "Business Property",
                help_text: l.getSWToolTips("business_property").text,
                input_type: "checkbox",
                input_editable: "03" == i.homeType,
                checked: !!_.BUSPR,
                input_value: "Include Coverage",
                premium: _.BUSPR && _.BUSPR.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.BUSPR.CurrentTermAmt, t) : "Not Covered",
                answer_key: "business_property"
              }), "AZ" != y && "CA" != y && "NC" != y && "NJ" != y && "TX" != y && "WA" != y && "CO" != y && "OH" != y && "VA" != y && "FL" != y && "PA" != y && "OR" != y && "IN" != y && "WI" != y && "KY" != y && "ID" != y && "NV" != y || (C.personal_injury = {
                title: "Personal Injury",
                help_text: l.getSWToolTips("personal_injury").text,
                input_type: "checkbox",
                checked: !!_.PIHOM,
                input_editable: !0,
                input_value: "Include Coverage",
                premium: _.PIHOM && _.PIHOM.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.PIHOM.CurrentTermAmt, t) : "Not Covered",
                answer_key: "personal_injury"
              }, console.log("brushForestError", i.brushForestError), i.brushForestError && "no" == i.brushForestError && ("WA" != y && "CO" != y && "VA" != y && "FL" != y && "TX" != y && "PA" != y ? C.wind_hail = {
                title: "Wind/Hail Deductible",
                help_text: l.getSWToolTips("wind_hail").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("wind_hail", i),
                premium: b.includes("WindHail") ? "Included" : "Not Covered",
                answer_key: "wind_hail"
              } : "CO" == y || "VA" == y ? b.includes("WindHail") && (w.wind_hail = {
                title: "Wind/Hail Deductible",
                help_text: l.getSWToolTips("wind_hail").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "wind_hail"
              }) : "TX" == y && b.includes("WindHail") && (w.wind_hail = {
                title: "Wind/Hail Deductible",
                help_text: l.getSWToolTips("wind_hail").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: "Included",
                answer_key: "wind_hail"
              }))), "TX" == y && (C.water_damage = {
                title: "Water Damage",
                help_text: l.getSWToolTips("water_damage").text,
                input_type: "checkbox",
                checked: !!_.WD,
                input_editable: !0,
                input_value: "Include Coverage",
                premium: _.WD && _.WD.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.WD.CurrentTermAmt, t) : "Not Covered",
                answer_key: "water_damage"
              }), "TX" == y && (C.foundation_coverage = {
                title: "Foundation Coverage",
                help_text: l.getSWToolTips("foundation_coverage").text,
                input_type: "checkbox",
                input_editable: !0,
                input_value: "Include Coverage",
                checked: !!_.FND,
                premium: _.FND && _.FND.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.FND.CurrentTermAmt, t) : "Not Covered",
                answer_key: "foundation_coverage"
              }), "NJ" == y && (C.hurricane_premium = {
                title: "Hurricane",
                help_text: l.getSWToolTips("hurricane").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _.HURR && _.HURR.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.HURR.CurrentTermAmt, t) : "",
                answer_key: "hurricane_premium"
              }, C.hurricane = {
                title: "Hurricane Deductible",
                help_text: l.getSWToolTips("hurricane").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("hurricane", i),
                premium: b.includes("HURR") ? "Included" : "Not Covered",
                answer_key: "hurricane"
              }), "TX" == y && (C.hurricane_premium = {
                title: "Hurricane",
                help_text: l.getSWToolTips("hurricane").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _.HURR && _.HURR.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.HURR.CurrentTermAmt, t) : "",
                answer_key: "hurricane_premium"
              }, b.includes("HURR") && (C.hurricane = {
                title: "Hurricane Deductible",
                help_text: l.getSWToolTips("hurricane").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("hurricane", i),
                premium: b.includes("HURR") ? "Included" : "Not Covered",
                answer_key: "hurricane"
              })), "FL" == y && b.includes("HURR") && (C.hurricane = {
                title: "Hurricane Deductible",
                help_text: l.getSWToolTips("hurricane").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("hurricane", i),
                premium: b.includes("HURR") ? "Included" : "Not Covered",
                answer_key: "hurricane"
              }), "AZ" != y && "VA" != y && "NC" != y && "NJ" != y && "WA" != y && "TX" != y && "CO" != y && "OH" != y && "OR" != y && "PA" != y && "IN" != y && "WI" != y && "KY" != y && "SC" != y && "ID" != y && "NV" != y || (U = "ERQK" + i.earthquake, C.earthquake = {
                title: "Earthquake",
                help_text: l.getSWToolTips("earthquake").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("earthquake", i),
                premium: _[U] && _[U].CurrentTermAmt ? "$" + l.getMonthlyPremiums(_[U].CurrentTermAmt, t) : "Not Covered",
                answer_key: "earthquake"
              }), "TX" == y && (C.limited_hurricane = {
                title: "Limited Hurricane Coverage",
                help_text: l.getSWToolTips("limited_hurricane").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("limited_hurricane", i),
                premium: _.LmtdHurricaneOutPrty && _.LmtdHurricaneOutPrty.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.LmtdHurricaneOutPrty.CurrentTermAmt, t) : "Not Covered",
                answer_key: "limited_hurricane"
              }), "TX" != y && "KY" != y && "SC" != y || (C.identity_recovery = {
                title: "Identity Recovery",
                help_text: l.getSWToolTips("identity_recovery").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("identity_recovery", i),
                premium: _.IdentityRecovery && _.IdentityRecovery.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.IdentityRecovery.CurrentTermAmt, t) : "Not Covered",
                answer_key: "identity_recovery"
              }), "VA" != y && "FL" != y || (w.identity_recovery = {
                title: "Identity Recovery",
                help_text: l.getSWToolTips("identity_recovery").text,
                input_type: "none",
                input_editable: !1,
                input_value: "",
                premium: _.IdentityRecovery && _.IdentityRecovery.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.IdentityRecovery.CurrentTermAmt, t) : "Not Covered",
                answer_key: "identity_recovery"
              }), "FL" == y && (C.spec_Computer = {
                title: "SPEC COMPUTER",
                help_text: l.getSWToolTips("spec_Computer").text,
                input_type: "dropdown",
                input_editable: !0,
                dropdown_values: l.getCustomizeOptions("spec_Computer", i),
                premium: _.SpecComputerCvg && _.SpecComputerCvg.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.SpecComputerCvg.CurrentTermAmt, t) : "Not Covered",
                answer_key: "spec_Computer"
              }, C.dog_Liability = {
                title: "Dog Liability Coverage",
                help_text: l.getSWToolTips("dog_Liability").text,
                input_type: "checkbox",
                input_editable: !0,
                input_value: "Include Coverage",
                checked: !!_.DogLiability,
                premium: _.DogLiability && _.DogLiability.CurrentTermAmt ? "$" + l.getMonthlyPremiums(_.DogLiability.CurrentTermAmt, t) : "Not Covered",
                answer_key: "dog_Liability"
              }), !a) {
                for (Q in w) delete w[Q].help_text;
                for (J in C) delete C[J].help_text;
              }
              return $ = {
                includedCoverage: w,
                optionalCoverage: C,
                discountApplied: v,
                sppList: c,
                quoteAmt: R,
                monthlyPremium: H,
                yearlyPremium: k,
                coverageJson: _
              }, console.log("cusomizeValues_03", $), console.log("commonCoverages_03", i), console.log("includedCoverage_09", w), console.log("optionalCoverage_06", C), console.log("swCoverages", u), console.log("coverageJson", _), e.abrupt("return", $);
            case 114:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return G.apply(this, arguments);
      })
    }, {
      key: "getSWHelpText",
      value: (B = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = new StillWaterHelper.StillWaterHelper(), e.abrupt("return", n.getSWToolTips(t).text || "");
            case 2:
            case "end":
              return e.stop();
          }
        }, e);
      })), function (e) {
        return B.apply(this, arguments);
      })
    }, {
      key: "checkSWAppFlowKnockout",
      value: (E = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i, o, s, l, u, c, m, p, d, g, _, y;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.saveCommonInput(t);
            case 2:
              return e.next = 4, this.swGetCustomizedPlan();
            case 4:
              return n = e.sent, a = {}, r = n.commonCoverages, i = this.getClientId(), e.next = 10, backendService.getAppData(i);
            case 10:
              return o = e.sent, o = (o = JSON.parse(o.Payload)).body, s = o.swQuoteId, l = unflatten(o.stillwater), console.log("appJson :", l), u = new StillWaterHelper.StillWaterHelper(), e.next = 19, u.checkSWKnockout(t, r, r.quoteId, l, this.id, s);
            case 19:
              if (c = e.sent, m = c.swOutput, p = c.commonCoverages, a = {
                swResponseJson: m,
                commonCoverages: p
              }, p.state = r.state, p.homeType = r.homeType, p.planType = r.planType, d = "", g = !1, _ = !1, !(m = m.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs).hasOwnProperty("MsgStatus") || "Error" != m.MsgStatus.MsgStatusCd._text && "Rejected" != m.MsgStatus.MsgStatusCd._text) {
                e.next = 36;
                break;
              }
              d = m.MsgStatus.MsgStatusDesc._text, g = !0, d.includes("Exception") && (_ = !0), e.next = 39;
              break;
            case 36:
              return y = flatten(a), e.next = 39, backendService.saveUpdateClientData(i, {
                swQuoteCustomizedPlan: y,
                id: i,
                clientId: i,
                uid: i
              });
            case 39:
              return e.abrupt("return", {
                message: d,
                knockout: g,
                hasError: _,
                counterOfferFlag: c.counterOfferFlag
              });
            case 40:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return E.apply(this, arguments);
      })
    }, {
      key: "getSWCustomizedQuote",
      value: (M = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n,
          a,
          r,
          i,
          o,
          s,
          l,
          u,
          c,
          m,
          p,
          d,
          g,
          _,
          y,
          h,
          w,
          C,
          v,
          S,
          b,
          A,
          x,
          f,
          P,
          I,
          T,
          O,
          N,
          R,
          k,
          H,
          D = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = D.length > 1 && void 0 !== D[1] ? D[1] : {}, console.log("swCustomizeParams_01", n), e.next = 4, this.saveCommonInput(t);
            case 4:
              return e.next = 6, this.swGetCustomizedPlan();
            case 6:
              for (u in a = e.sent, r = {}, i = this.getClientId(), o = a.commonCoverages, s = ["other_structure", "hurricane_premium"], l = [], console.log("Customize coverages swCustomizeParams:", n, "commonCoverages", o), o) console.log("Customize coverages 1 :", u, o[u], n[u]), n.hasOwnProperty(u) && !s.includes(u) && (console.log("Customize coverages 2 :", u, o[u], n[u]), "dwelling" == u ? (o.final_dwell = n[u], console.log("Customize coverages 2 :", "final_dwell", o.final_dwell, n[u]), o.dwelling = 100) : "personal_property" == u ? (o.personal_property = n[u].split("-")[0], o.acc_rc = n[u].split("-")[1]) : "business_property" == u && 1 != n[u] ? o.business_property = null : "home_cyberbase" == u || "hcbpackage_databreach" == u || "hcbbreach_bullying" == u || "homesys_protect" == u || "serviceline" == u ? (l = [], null == n[u] || "" == n[u] ? o[u] = null : (l = n[u].split("-"), o[u] = [l[0], l[1]])) : "identity_protection" == u ? "AZ" == o.state || "NJ" == o.state || "FL" == o.state ? o[u] = 25e3 : "WA" == o.state && (o[u] = n[u]) : o[u] = n[u] ? n[u] : null);
              return c = "", e.next = 17, backendService.getAppData(i);
            case 17:
              return m = e.sent, m = (m = JSON.parse(m.Payload)).body, c = m.swQuoteId, m.stillwater && unflatten(m.stillwater), p = o.quoteId + "_" + Date.now(), d = new StillWaterHelper.StillWaterHelper(), console.log("Customize coverages1: ", o), e.next = 27, d.getCustomizedSWQuote(t, o, o.quoteId, p, c);
            case 27:
              if (g = e.sent, _ = g.swOutput, console.log("getCustomizedSWQuote output", JSON.stringify(_)), (y = g.commonCoverages).state = o.state, y.homeType = o.homeType, y.planType = o.planType, h = 0, w = 0, C = "", v = 0, S = 0, b = 0, A = "", !(_ = _.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs).hasOwnProperty("MsgStatus") || "Error" != _.MsgStatus.MsgStatusCd._text && "Rejected" != _.MsgStatus.MsgStatusCd._text) {
                e.next = 47;
                break;
              }
              C = _.MsgStatus.MsgStatusDesc._text, console.log("getCustomizedSWQuote error", C), e.next = 67;
              break;
            case 47:
              if (!_.hasOwnProperty("HomeLineBusiness")) {
                e.next = 67;
                break;
              }
              return h = _.PersPolicy.PaymentOption.filter(function (e) {
                return "com.stillwater_EF12" == e.PaymentPlanCd._text;
              })[0], x = Number(h.TotalPremium._text.replace(/[^0-9.-]+/g, "")), console.log("newMonthlyPremium", x), x = (x / 12).toFixed(2), console.log("newMonthlyPremium", x), h = x, S = (S / 12).toFixed(0), S = _.PolicySummaryInfo.FullTermAmt.Amt._text, _.PolicySummaryInfo["com.stillwater_PackagePremium"].Amt && (b = ((b = _.PolicySummaryInfo["com.stillwater_PackagePremium"].Amt._text) / 12).toFixed(0)), w = (w = _.HomeLineBusiness.Dwell.Coverage.filter(function (e) {
                return "DWELL" == e.CoverageCd._text;
              })[0]).Limit.FormatInteger._text, v = _.HomeLineBusiness.Dwell.TotalInsurableReplCostAmt.Amt._text, y.final_dwell = w, r = {
                swResponseJson: g.swOutput,
                commonCoverages: y
              }, A = (A = _.HomeLineBusiness.Dwell.Coverage.filter(function (e) {
                return "LOU" == e.CoverageCd._text;
              })[0]).Limit.FormatInteger._text, f = flatten(r), e.next = 67, backendService.saveUpdateClientData(i, {
                swQuoteCustomizedPlan: f,
                id: i,
                clientId: i,
                uid: i
              });
            case 67:
              return P = 0, P = "06" == y.homeType ? +y.personal_property : (+w * +y.personal_property / 100).toFixed(0), I = this.getSWPlansText(), T = {
                economy: "PRIMARY",
                best: "POPULAR",
                expanded: "PREMIUM"
              }, O = d.getDynamicLabels(y), N = d.getHcbData(y), "AZ" == t.state || "NJ" == t.state || "OH" == t.state || "TX" == t.state ? (R = "Covered", k = d.getSWToolTips("identity_recovery")) : (R = y.identity_protection ? "$" + this.numberWithCommas(y.identity_protection) : "Not Covered", k = d.getSWToolTips("identity_protection")), H = {
                quoteId: p,
                carrierId: o.planType,
                replacementCost: "$" + this.numberWithCommas(v),
                loss_of_use: "06" == y.homeType ? "$" + this.numberWithCommas(parseInt(A)) : "$" + this.numberWithCommas(parseInt(40 * +v / 100)),
                quoteLabels: O,
                head: {
                  carrier_name: T[o.planType],
                  quote_amount: h,
                  packagePremium: S,
                  packagePremiumDiscounted: b,
                  home_insurance_carrier: "Stillwater",
                  carrier_icon: "",
                  grade: "A+",
                  grade_text: "A.M Best"
                },
                body: {
                  text: I[o.planType],
                  other_amounts: {
                    deductible: {
                      title: "Deductible",
                      text: "$" + this.numberWithCommas(y.deductible),
                      help_text: d.getSWToolTips("deductible")
                    },
                    liability: {
                      title: "Liability Coverage",
                      text: "$" + this.numberWithCommas(y.liability),
                      help_text: d.getSWToolTips("liability")
                    },
                    personal_prop: {
                      title: "Personal Property",
                      text: "$" + this.numberWithCommas(P),
                      help_text: d.getSWToolTips("personal_property")
                    },
                    dwelling: {
                      title: "Dwelling Coverage",
                      text: "$" + this.numberWithCommas(w),
                      help_text: d.getSWToolTips("dwelling")
                    }
                  }
                },
                planDetails: {
                  text: "Stillwater's Homeowners Insurance includes extensive coverage that provides peace of mind. All this at an affordable cost with additional discounts that help you save.",
                  coverages: {
                    medical_payment: y.medical_payment ? "$" + this.numberWithCommas(y.medical_payment) : "Not Covered",
                    water_backup: y.water_backup ? "$" + this.numberWithCommas(y.water_backup) : "Not Covered",
                    hcb: N,
                    homesystem: y.homesys_protect ? "$" + this.numberWithCommas(y.homesys_protect[0]) + "/ $" + this.numberWithCommas(y.homesys_protect[1]) : "Not Covered",
                    id_protection: R,
                    service_line: y.serviceline ? "$" + this.numberWithCommas(y.serviceline[0]) + "/ $" + this.numberWithCommas(y.serviceline[1]) : "Not Covered",
                    medical_payment_help_text: d.getSWToolTips("medical_payment"),
                    water_backup_help_text: d.getSWToolTips("water_backup"),
                    hcb_help_text: d.getSWToolTips("home_cyberbase"),
                    homesystem_help_text: d.getSWToolTips("homesys_protect"),
                    id_protection_help_text: k,
                    service_line_help_text: d.getSWToolTips("serviceline")
                  }
                }
              }, C && C.length > 0 && (H.errorMessage = C, H.message = C, H.hasError = !0), e.abrupt("return", H);
            case 77:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return M.apply(this, arguments);
      })
    }, {
      key: "getSWSelectedFormattedQuote",
      value: (F = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r, i, o, s, l, u, c, m, p, d, g, _, y, h, w, C;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, this.swGetCustomizedPlan();
            case 2:
              return t = e.sent, n = t.commonCoverages, a = t.swResponseJson, r = 0, i = 0, o = "", s = "", l = 0, u = 0, c = new StillWaterHelper.StillWaterHelper(), (a = a.ACORD.InsuranceSvcRs.HomePolicyQuoteInqRs).hasOwnProperty("MsgStatus") && "Error" == a.MsgStatus.MsgStatusCd._text ? (o = a.MsgStatus.MsgStatusDesc._text, console.log("getCustomizedSWQuote error", o)) : a.hasOwnProperty("HomeLineBusiness") && (r = a.PersPolicy.PaymentOption.filter(function (e) {
                return "com.stillwater_EF12" == e.PaymentPlanCd._text;
              })[0], m = Number(r.TotalPremium._text.replace(/[^0-9.-]+/g, "")), console.log("newMonthlyPremium", m), m = (m / 12).toFixed(2), console.log("newMonthlyPremium", m), r = m, l = ((l = a.PolicySummaryInfo.FullTermAmt.Amt._text) / 12).toFixed(0), console.log("swOutput.PolicySummaryInfo", a.PolicySummaryInfo), a.PolicySummaryInfo.com.stillwater_PackagePremium.Amt && (u = ((u = a.PolicySummaryInfo.com.stillwater_PackagePremium.Amt._text) / 12).toFixed(0)), i = (i = a.HomeLineBusiness.Dwell.Coverage.filter(function (e) {
                return "DWELL" == e.CoverageCd._text;
              })[0]).Limit.FormatInteger._text, s = a.HomeLineBusiness.Dwell.TotalInsurableReplCostAmt.Amt._text), p = 0, p = "06" == n.homeType ? +n.personal_property : (+i * +n.personal_property / 100).toFixed(0), d = {
                economy: "PRIMARY",
                best: "POPULAR",
                expanded: "PREMIUM"
              }, g = c.getDynamicLabels(n), _ = c.getHcbData(n), y = this.getSWPlansText(), h = n.identity_protection ? "$" + this.numberWithCommas(n.identity_protection) : "Not Covered", w = c.getSWToolTips("identity_protection"), C = {
                quoteId: n.quoteId,
                carrierId: n.planType,
                replacementCost: "$" + this.numberWithCommas(s),
                quoteLabels: g,
                head: {
                  carrier_name: d[n.planType],
                  quote_amount: r,
                  packagePremium: l,
                  packagePremiumDiscounted: u,
                  home_insurance_carrier: "Stillwater",
                  carrier_icon: "",
                  grade: "A+",
                  grade_text: "A.M Best"
                },
                body: {
                  text: y[n.planType],
                  other_amounts: {
                    deductible: {
                      title: "Deductible",
                      text: "$" + this.numberWithCommas(n.deductible),
                      help_text: c.getSWToolTips("deductible")
                    },
                    liability: {
                      title: "Liability Coverage",
                      text: "$" + this.numberWithCommas(n.liability),
                      help_text: c.getSWToolTips("liability")
                    },
                    personal_prop: {
                      title: "Personal Property",
                      text: "$" + this.numberWithCommas(p),
                      help_text: c.getSWToolTips("personal_property")
                    },
                    dwelling: {
                      title: "Dwelling Coverage",
                      text: "$" + this.numberWithCommas(i),
                      help_text: c.getSWToolTips("dwelling")
                    }
                  }
                },
                planDetails: {
                  text: "Stillwater's Homeowners Insurance includes extensive coverage that provides peace of mind. All this at an affordable cost with additional discounts that help you save.",
                  coverages: {
                    medical_payment: n.medical_payment ? "$" + this.numberWithCommas(n.medical_payment) : "Not Covered",
                    water_backup: n.water_backup ? "$" + this.numberWithCommas(n.water_backup) : "Not Covered",
                    hcb: _,
                    homesystem: n.homesys_protect ? "$" + this.numberWithCommas(n.homesys_protect[0]) + "/ $" + this.numberWithCommas(n.homesys_protect[1]) : "Not Covered",
                    id_protection: h,
                    service_line: n.serviceline ? "$" + this.numberWithCommas(n.serviceline[0]) + "/ $" + this.numberWithCommas(n.serviceline[1]) : "Not Covered",
                    medical_payment_help_text: c.getSWToolTips("medical_payment"),
                    water_backup_help_text: c.getSWToolTips("water_backup"),
                    hcb_help_text: c.getSWToolTips("home_cyberbase"),
                    homesystem_help_text: c.getSWToolTips("homesys_protect"),
                    id_protection_help_text: w,
                    service_line_help_text: c.getSWToolTips("serviceline")
                  }
                }
              }, e.abrupt("return", C);
            case 24:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return F.apply(this, arguments);
      })
    }, {
      key: "getCommonInput",
      value: (L = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return e.next = 2, backendService.getAppData(this.id);
            case 2:
              return t = e.sent, t = (t = JSON.parse(t.Payload)).body, e.abrupt("return", t.commonInput ? unflatten(t.commonInput) : {});
            case 6:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return L.apply(this, arguments);
      })
    }, {
      key: "getSWKnockoutQuestionsByState",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "1999",
          n = this.getAge("01/01/" + t),
          a = "03";
        n < 50 && (a = "05");
        var r = [{
            question_sequence: 1,
            answer_label: "None of these apply",
            answer_text: "",
            inactive_image_url: "assets/images/SWAppFlow/ic-none.png",
            active_image_url: "assets/images/SWAppFlow/ic-none-active.png",
            answer_key: "sw_additionalInfoNone",
            sw_questionId: null
          }, {
            question_sequence: 2,
            answer_label: " Property is not my full-time Primary Residence",
            answer_text: "",
            inactive_image_url: "assets/images/SWAppFlow/ic-standard.png",
            active_image_url: "assets/images/SWAppFlow/ic-standard-active.png",
            answer_key: "sw_primaryResidence",
            sw_questionId: 111
          }, {
            question_sequence: 3,
            answer_label: "Pre-existing damage to the property",
            answer_text: "This includes, but is not limited to, exterior wall damage, excessive peeling paint, damaged soffits or fascia, broken windows or doors, chimney damage, etc.",
            inactive_image_url: "assets/images/SWAppFlow/ic-existing-damage.png",
            active_image_url: "assets/images/SWAppFlow/ic-existing-damage-active.png",
            answer_key: "sw_additionalInfoPreExistingDamage",
            sw_questionId: 375
          }, {
            question_sequence: 4,
            answer_label: "Unit is occupied by more than 1 family",
            answer_text: "Bubble Insures only single-family homes. Meaning, a house occupied by only one family.",
            inactive_image_url: "assets/images/SWAppFlow/ic-more-family.png",
            active_image_url: "assets/images/SWAppFlow/ic-more-family-active.png",
            answer_key: "sw_additionalInfoMoreThanOneFamily",
            sw_questionId: 525
          }, {
            question_sequence: 5,
            answer_label: "Experience a lapse in coverage",
            answer_text: "Has the applicant experienced a lapse in coverage during the past 36 months?",
            inactive_image_url: "assets/images/SWAppFlow/ic-coverage-lapse.png",
            active_image_url: "assets/images/SWAppFlow/ic-coverage-lapse-active.png",
            answer_key: "sw_additionalInfoLapseinCoverage",
            sw_questionId: 25
          }, {
            question_sequence: 6,
            answer_label: "Experienced cancellation for non-payment",
            answer_text: "Has the applicant experienced more than 2 cancellations for non-payment of the premium during the past 36 months? ",
            inactive_image_url: "assets/images/SWAppFlow/ic-non-payment.png",
            active_image_url: "assets/images/SWAppFlow/ic-non-payment-active.png",
            answer_key: "sw_additionalInfoCancellation",
            sw_questionId: 43
          }, {
            question_sequence: 7,
            answer_label: "Business conducted on the property which entails foot traffic",
            answer_text: "If the applicant runs any businesses with foot traffic into your home (e.g. hairdresser, counselor, daycare), Bubble is unable to cover homes with such on-site businesses.",
            inactive_image_url: "assets/images/SWAppFlow/ic-business-conducted.png",
            active_image_url: "assets/images/SWAppFlow/ic-business-conducted-active.png",
            answer_key: "sw_additionalInfoFootTraffic",
            sw_questionId: 3050
          }, {
            question_sequence: 8,
            answer_label: "Dwelling is vacant",
            answer_text: "This will not apply if the New Purchase to be occupied within 60 days after purchase.",
            inactive_image_url: "assets/images/SWAppFlow/ic-vacant-dwelling.png",
            active_image_url: "assets/images/SWAppFlow/ic-vacant-dwelling-active.png",
            answer_key: "sw_additionalInfoDwellingNotVacant",
            sw_questionId: 2256
          }],
          i = [{
            question_sequence: 1,
            answer_label: "None of these apply",
            answer_text: "",
            inactive_image_url: "assets/images/SWAppFlow/ic-none.png",
            active_image_url: "assets/images/SWAppFlow/ic-none-active.png",
            answer_key: "sw_additionalInfoNone",
            sw_questionId: null
          }, {
            question_sequence: 2,
            answer_label: " Property is not my full-time Primary Residence",
            answer_text: "",
            inactive_image_url: "assets/images/SWAppFlow/ic-standard.png",
            active_image_url: "assets/images/SWAppFlow/ic-standard-active.png",
            answer_key: "sw_primaryResidence",
            sw_questionId: 111
          }, {
            question_sequence: 3,
            answer_label: "Pre-existing damage to the property",
            answer_text: "This includes, but is not limited to, exterior wall damage, excessive peeling paint, damaged soffits or fascia, broken windows or doors, chimney damage, etc.",
            inactive_image_url: "assets/images/SWAppFlow/ic-existing-damage.png",
            active_image_url: "assets/images/SWAppFlow/ic-existing-damage-active.png",
            answer_key: "sw_additionalInfoPreExistingDamage",
            sw_questionId: 375
          }, {
            question_sequence: 4,
            answer_label: "Unit is occupied by more than 1 family",
            answer_text: "Bubble Insures only single-family homes. Meaning, a house occupied by only one family.",
            inactive_image_url: "assets/images/SWAppFlow/ic-more-family.png",
            active_image_url: "assets/images/SWAppFlow/ic-more-family-active.png",
            answer_key: "sw_additionalInfoMoreThanOneFamily",
            sw_questionId: 525
          }, {
            question_sequence: 5,
            answer_label: "Business conducted on the property which entails foot traffic",
            answer_text: "If the applicant runs any businesses with foot traffic into your home (e.g. hairdresser, counselor, daycare), Bubble is unable to cover homes with such on-site businesses.",
            inactive_image_url: "assets/images/SWAppFlow/ic-business-conducted.png",
            active_image_url: "assets/images/SWAppFlow/ic-business-conducted-active.png",
            answer_key: "sw_additionalInfoFootTraffic",
            sw_questionId: 3050
          }, {
            question_sequence: 6,
            answer_label: "Dwelling is vacant",
            answer_text: "This will not apply if the New Purchase to be occupied within 60 days after purchase.",
            inactive_image_url: "assets/images/SWAppFlow/ic-vacant-dwelling.png",
            active_image_url: "assets/images/SWAppFlow/ic-vacant-dwelling-active.png",
            answer_key: "sw_additionalInfoDwellingNotVacant",
            sw_questionId: 2256
          }];
        return "CA" == e ? "03" == a ? i : r : i;
      }
    }, {
      key: "saveCommonInput",
      value: (W = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = (n = this.id.split("-"))[0], a = flatten(t), e.next = 5, backendService.saveUpdateClientData(n, {
                commonInput: a,
                id: n,
                clientId: n,
                uid: n
              });
            case 5:
              return r = e.sent, e.abrupt("return", r);
            case 7:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return W.apply(this, arguments);
      })
    }, {
      key: "getClientId",
      value: function () {
        var e = this.id.split("-");
        return e = e[0];
      }
    }, {
      key: "getSWCABuilders",
      value: function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "CA",
          t = [{
            name: "American Heritage Communities",
            id: 196
          }, {
            name: "Anderson Homes",
            id: 210
          }, {
            name: "ANR Homes",
            id: 186
          }, {
            name: "ANTHEM UNITED",
            id: 267
          }, {
            name: "Atherton Homes",
            id: 139
          }, {
            name: "Barratt American",
            id: 112
          }, {
            name: "Beazer Homes",
            id: 109
          }, {
            name: "Berry Construction",
            id: 229
          }, {
            name: "Blu Sky Homes",
            id: 122
          }, {
            name: "Brehm Communities",
            id: 214
          }, {
            name: "Brookfield Homes",
            id: 130
          }, {
            name: "CalAtlantic Homes",
            id: 261
          }, {
            name: "California Home Builders Inc",
            id: 191
          }, {
            name: "Cambridge Homes",
            id: 153
          }, {
            name: "Capital Pacific Homes",
            id: 162
          }, {
            name: "Centex",
            id: 100
          }, {
            name: "Century Vintage Homes",
            id: 136
          }, {
            name: "Christopherson Homes",
            id: 154
          }, {
            name: "Clyde Miles Construction",
            id: 142
          }, {
            name: "Corman Leigh",
            id: 119
          }, {
            name: "Cornerstone Communities",
            id: 235
          }, {
            name: "Covenant Development Inc",
            id: 199
          }, {
            name: "DR Horton",
            id: 98
          }, {
            name: "Davidon Homes",
            id: 173
          }, {
            name: "Del Webb Corporation National Home Builder",
            id: 155
          }, {
            name: "Diversified Pacific",
            id: 220
          }, {
            name: "Drummond",
            id: 145
          }, {
            name: "Dunmore Homes",
            id: 156
          }, {
            name: "Elliott Homes",
            id: 121
          }, {
            name: "Ennis Homes",
            id: 184
          }, {
            name: "Fieldstone Communities Inc",
            id: 189
          }, {
            name: "First Pacifica Housing Corp",
            id: 187
          }, {
            name: "Frontier Homes",
            id: 176
          }, {
            name: "FSZ Bros General Contractors",
            id: 230
          }, {
            name: "GFR Enterprises Inc",
            id: 218
          }, {
            name: "Glenwood Communities",
            id: 125
          }, {
            name: "Grande Construction",
            id: 192
          }, {
            name: "Griffin Communities",
            id: 138
          }, {
            name: "Group Meeker",
            id: 149
          }, {
            name: "Hallmark Communities",
            id: 129
          }, {
            name: "Harris Homes Inc",
            id: 195
          }, {
            name: "Heritage Pacific Homes",
            id: 148
          }, {
            name: "Howard Roberts Developments",
            id: 123
          }, {
            name: "Irvine Pacific",
            id: 260
          }, {
            name: "JMC Homes",
            id: 137
          }, {
            name: "John Laing Homes",
            id: 124
          }, {
            name: "Joseph Nicholas Homes",
            id: 222
          }, {
            name: "JTS Builders",
            id: 111
          }, {
            name: "K Hovnanian",
            id: 102
          }, {
            name: "KB Homes",
            id: 99
          }, {
            name: "Kimball Hill Homes",
            id: 157
          }, {
            name: "Lakemont Homes",
            id: 181
          }, {
            name: "Lennar",
            id: 97
          }, {
            name: "Lenox Homes",
            id: 217
          }, {
            name: "Mark La Charite Homes Inc",
            id: 231
          }, {
            name: "Matthews Homes",
            id: 166
          }, {
            name: "MBK Homes",
            id: 209
          }, {
            name: "McMillin Homes",
            id: 182
          }, {
            name: "Meritage Homes",
            id: 126
          }, {
            name: "Morrison Homes",
            id: 183
          }, {
            name: "New Builder Requested",
            id: 99999
          }, {
            name: "New Millennium Homes",
            id: 168
          }, {
            name: "New West Home",
            id: 133
          }, {
            name: "Oasis Homes",
            id: 197
          }, {
            name: "Origin Construction",
            id: 207
          }, {
            name: "Osborne Development Corp",
            id: 227
          }, {
            name: "Pacific Century Homes",
            id: 120
          }, {
            name: "Pacific Communities",
            id: 106
          }, {
            name: "Pacific Scene Homes",
            id: 204
          }, {
            name: "Pacific Union Homes",
            id: 134
          }, {
            name: "Paragon Communities",
            id: 118
          }, {
            name: "Paramont Homes",
            id: 152
          }, {
            name: "Pardee Homes",
            id: 114
          }, {
            name: "Parkland Homes",
            id: 158
          }, {
            name: "Ponderosa Homes",
            id: 257
          }, {
            name: "Prestige Homes",
            id: 143
          }, {
            name: "Pulte Homes",
            id: 103
          }, {
            name: "Ranch Wood Homes",
            id: 135
          }, {
            name: "RB Communities",
            id: 171
          }, {
            name: "Richmond Homes",
            id: 104
          }, {
            name: "RWR Homes",
            id: 212
          }, {
            name: "Ryder Homes",
            id: 201
          }, {
            name: "Ryland Homes",
            id: 108
          }, {
            name: "San Joaquin Valley Homes",
            id: 264
          }, {
            name: "SBI Smee Builders Inc",
            id: 232
          }, {
            name: "Seeno Homes",
            id: 159
          }, {
            name: "Shapell Homes",
            id: 233
          }, {
            name: "Shea Homes",
            id: 128
          }, {
            name: "Sheffield Homes",
            id: 202
          }, {
            name: "SILICONSAGE® HOMES",
            id: 268
          }, {
            name: "SS Homes",
            id: 113
          }, {
            name: "Standard Pacific",
            id: 101
          }, {
            name: "Standard Pacific Homes",
            id: 221
          }, {
            name: "Steven Walker Homes",
            id: 224
          }, {
            name: "Stone Field Development",
            id: 205
          }, {
            name: "Stratham Homes",
            id: 200
          }, {
            name: "Syncon Homes",
            id: 141
          }, {
            name: "Taylor Morison",
            id: 215
          }, {
            name: "Taylor Morrison",
            id: 203
          }, {
            name: "Taylor Woodrow",
            id: 117
          }, {
            name: "The Grupe Company",
            id: 167
          }, {
            name: "The OBrien Group",
            id: 160
          }, {
            name: "Tim Lewis Communities",
            id: 175
          }, {
            name: "Toll Brothers",
            id: 107
          }, {
            name: "Trimark Homes",
            id: 178
          }, {
            name: "Van Daele Homes",
            id: 146
          }, {
            name: "Victoria Homes Inc",
            id: 170
          }, {
            name: "Warmington Homes",
            id: 161
          }, {
            name: "William Lyon Homes",
            id: 105
          }, {
            name: "WILLIAMS HOMES INC",
            id: 266
          }, {
            name: "Woodside Homes",
            id: 116
          }, {
            name: "Young Homes",
            id: 151
          }, {
            name: "Castle & Cooke",
            id: 131
          }],
          n = [{
            id: "1",
            name: "All American Homes"
          }, {
            id: "256",
            name: "Altura Homes"
          }, {
            id: "2",
            name: "American Legend Homes"
          }, {
            id: "132",
            name: "Antares Homes"
          }, {
            id: "206",
            name: "Armadillo Homes"
          }, {
            id: "174",
            name: "Ashton Woods Homes"
          }, {
            id: "3",
            name: "Avery Edwards Custom Homes"
          }, {
            id: "4",
            name: "Beazer Homes"
          }, {
            id: "258",
            name: "Bella Vista Homes"
          }, {
            id: "5",
            name: "Best Homes"
          }, {
            id: "6",
            name: "Betenbough Homes"
          }, {
            id: "93",
            name: "Bloomfield Homes"
          }, {
            id: "208",
            name: "Blue Haven Homes"
          }, {
            id: "7",
            name: "Bowen Family Homes"
          }, {
            id: "8",
            name: "Buescher Homes"
          }, {
            id: "226",
            name: "Buffington Texas Classic Homes"
          }, {
            id: "9",
            name: "Calmark Homes/ Calsouth Corp. "
          }, {
            id: "10",
            name: "Cameron Lee Michael Fine Homes"
          }, {
            id: "11",
            name: "Carlisle Homes, Inc."
          }, {
            id: "12",
            name: "Casas Modernas, LLC"
          }, {
            id: "263",
            name: "Castlerock Communities"
          }, {
            id: "13",
            name: "Centex Homes"
          }, {
            id: "14",
            name: "Cervelle Homes Inc."
          }, {
            id: "150",
            name: "Cheldan Homes"
          }, {
            id: "255",
            name: "Chesmar Homes"
          }, {
            id: "15",
            name: "Choice Homes"
          }, {
            id: "16",
            name: "Classic Century Homes LTD"
          }, {
            id: "17",
            name: "Coachman Homes Inc."
          }, {
            id: "82",
            name: "Coleman Homes"
          }, {
            id: "223",
            name: "Compass Pointe Homes"
          }, {
            id: "18",
            name: "Continental Home"
          }, {
            id: "19",
            name: "Countryside Homes"
          }, {
            id: "20",
            name: "Coventry Homes"
          }, {
            id: "21",
            name: "Creative Homes"
          }, {
            id: "22",
            name: "D.R. Horton"
          }, {
            id: "23",
            name: "Darling Homes"
          }, {
            id: "24",
            name: "David Powers Homes"
          }, {
            id: "25",
            name: "David Weekley Homes"
          }, {
            id: "26",
            name: "Deerwood Homes"
          }, {
            id: "27",
            name: "Diamond Homes"
          }, {
            id: "28",
            name: "Drees Homes"
          }, {
            id: "29",
            name: "Eagle Valley Homes"
          }, {
            id: "30",
            name: "Engle Homes, Inc."
          }, {
            id: "31",
            name: "Fieldstone Communities LLC"
          }, {
            id: "94",
            name: "First Texas Homes"
          }, {
            id: "32",
            name: "Fox & Jacobs"
          }, {
            id: "84",
            name: "Gateway Homes"
          }, {
            id: "33",
            name: "Gehan Homes Builders"
          }, {
            id: "165",
            name: "Goff Homes"
          }, {
            id: "34",
            name: "Goodman Homes"
          }, {
            id: "90",
            name: "Graham Hart Home Builder"
          }, {
            id: "147",
            name: "Grand Homes"
          }, {
            id: "35",
            name: "H Baca Custom Homes, Inc."
          }, {
            id: "36",
            name: "Hampton Homes"
          }, {
            id: "37",
            name: "Heritage Homes"
          }, {
            id: "262",
            name: "Highland Builders"
          }, {
            id: "38",
            name: "Highland Homes"
          }, {
            id: "39",
            name: "History Maker Homes"
          }, {
            id: "40",
            name: "Homes by Towne of Texas"
          }, {
            id: "41",
            name: "Horizon Homes"
          }, {
            id: "228",
            name: "J. Patrick Homes"
          }, {
            id: "42",
            name: "JM Custom Homes LLC"
          }, {
            id: "164",
            name: "K. Hovnanian Homes"
          }, {
            id: "43",
            name: "KB Homes"
          }, {
            id: "44",
            name: "Kimball Hill Homes"
          }, {
            id: "45",
            name: "Legacy Homes"
          }, {
            id: "46",
            name: "Legend Homes"
          }, {
            id: "92",
            name: "Lennar"
          }, {
            id: "47",
            name: "Lennar/ US Home Corp"
          }, {
            id: "48",
            name: "LGI Homes, LTD"
          }, {
            id: "49",
            name: "Liberty First Homes"
          }, {
            id: "50",
            name: "Life Forms Inc"
          }, {
            id: "51",
            name: "Long Lake"
          }, {
            id: "91",
            name: "Main Street Homes"
          }, {
            id: "216",
            name: "Maverick Homes"
          }, {
            id: "87",
            name: "McBee Homes"
          }, {
            id: "52",
            name: "McGuyer Homes Builders Inc"
          }, {
            id: "53",
            name: "McMilen Home Builders"
          }, {
            id: "85",
            name: "McMillin Homes"
          }, {
            id: "54",
            name: "Mercedes Homes"
          }, {
            id: "55",
            name: "Meridian Homes"
          }, {
            id: "88",
            name: "Meritage Homes"
          }, {
            id: "225",
            name: "Montreaux Luxury Homes"
          }, {
            id: "56",
            name: "Morrison Homes"
          }, {
            id: "219",
            name: "Murphy Homes Group"
          }, {
            id: "172",
            name: "Newmark Homes"
          }, {
            id: "57",
            name: "North Shore Builders LLC"
          }, {
            id: "58",
            name: "NuHome/ Part of Lennar"
          }, {
            id: "234",
            name: "NuWay Homes"
          }, {
            id: "59",
            name: "Obra Homes"
          }, {
            id: "89",
            name: "Old Field Fine Homes"
          }, {
            id: "193",
            name: "Paul Taylor Homes"
          }, {
            id: "60",
            name: "Perry Homes"
          }, {
            id: "61",
            name: "Pioneer Homes"
          }, {
            id: "62",
            name: "Plantation Homes"
          }, {
            id: "63",
            name: "Premier Homes Inc"
          }, {
            id: "64",
            name: "Princetion Classic Homes"
          }, {
            id: "65",
            name: "Pulte Homes"
          }, {
            id: "115",
            name: "Rendon-Homes"
          }, {
            id: "66",
            name: "Residential Solutions Inc."
          }, {
            id: "163",
            name: "Reytex Homes"
          }, {
            id: "67",
            name: "Richmond Homes"
          }, {
            id: "68",
            name: "Robbie Hales Homes"
          }, {
            id: "69",
            name: "Roma Homes Inc"
          }, {
            id: "70",
            name: "Royce Family of Builders"
          }, {
            id: "71",
            name: "Ryland Homes"
          }, {
            id: "198",
            name: "Sagewood Homes Inc"
          }, {
            id: "72",
            name: "Sandlin Custom Homes"
          }, {
            id: "73",
            name: "Shepard Place Homes, Inc"
          }, {
            id: "95",
            name: "Sheridan Homes"
          }, {
            id: "96",
            name: "Sotherby Homes"
          }, {
            id: "194",
            name: "Stand Pacific Homes"
          }, {
            id: "185",
            name: "Steelman Homes - Capital Freedom Homes"
          }, {
            id: "74",
            name: "Steve Hawkins Custom Homes LTD"
          }, {
            id: "110",
            name: "Sumeer Homes"
          }, {
            id: "75",
            name: "Superior Builders"
          }, {
            id: "83",
            name: "Supreme Builders"
          }, {
            id: "76",
            name: "Sycamore Homes"
          }, {
            id: "169",
            name: "Taylor Woodrow Homes"
          }, {
            id: "259",
            name: "Texas Capital Builders"
          }, {
            id: "77",
            name: "TexSum Home Builders"
          }, {
            id: "179",
            name: "Tilson Homes"
          }, {
            id: "86",
            name: "Toll Brothers"
          }, {
            id: "213",
            name: "Touch Mark Homes"
          }, {
            id: "188",
            name: "Trend maker Homes"
          }, {
            id: "190",
            name: "Uptmore Homes"
          }, {
            id: "78",
            name: "US 287 IP Development, Inc"
          }, {
            id: "79",
            name: "US Homes"
          }, {
            id: "80",
            name: "Vantage Homes, Inc./ Vantage Builders of Texas"
          }, {
            id: "177",
            name: "Wall Homes"
          }, {
            id: "211",
            name: "Westin Homes"
          }, {
            id: "81",
            name: "Woodhaven Homes"
          }];
        return "CA" == e ? t : n;
      }
    }, {
      key: "getSWPropertyOptions",
      value: function () {
        return {
          home_type: [{
            value: "DW",
            text: "Single Family Home"
          }],
          stories: [{
            value: "1",
            text: "1"
          }, {
            value: "1H",
            text: "1.5 (attic)"
          }, {
            value: "2",
            text: "2"
          }, {
            value: "2H",
            text: "2.5 (attic)"
          }, {
            value: "3",
            text: "3"
          }, {
            value: "4",
            text: "4+"
          }],
          roof_type: [{
            value: "ARCH",
            text: "Architectural Shingles",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "ASPHS",
            text: "Asphalt Shingle",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "CLAY",
            text: "Clay Tile or Slate",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "COMP",
            text: "Composition (Fiberglass, Asphalt, etc.)",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "CONC",
            text: "Concrete Tile",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "CONCRETE",
            text: "Concrete (Not Tile)",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "FIBER",
            text: "Fiberglass",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "FOAM",
            text: "Foam",
            states: ["CA", "AZ"]
          }, {
            value: "LTMTLPNL",
            text: "Light Metal Panel",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "MEMSINGLEBALL",
            text: "Single Ply Membrane Ballasted",
            states: ["CA", "AZ"]
          }, {
            value: "MINFR",
            text: "Mineral Fiber",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "MissTile",
            text: "Mission Tile",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "PLAS",
            text: "Plastic",
            states: ["CA", "AZ"]
          }, {
            value: "ROCK",
            text: "Rock",
            states: ["CA", "AZ"]
          }, {
            value: "SPMS",
            text: "Single Ply Membrane Systems",
            states: ["CA", "AZ"]
          }, {
            value: "TAR",
            text: "Tar and Gravel",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "GRAVL",
            text: "Gravel",
            states: ["CA", "AZ"]
          }, {
            value: "HAIL",
            text: "Hail",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "METL",
            text: "Metal",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "RECYC",
            text: "Recycled Roofing Products",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "RUBB",
            text: "Rubber Roof",
            states: ["CA", "AZ"]
          }, {
            value: "SLAT",
            text: "Slate",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "SpTile",
            text: "Spanish Tile",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }, {
            value: "TARGRB",
            text: "Tar and Gravel (Built-up)",
            states: ["CA", "AZ"]
          }, {
            value: "TILE",
            text: "Tile",
            states: ["CA", "MA", "NJ", "VA", "AZ", "NC"]
          }],
          construction_type: [{
            value: "Aluminum",
            text: "Aluminum"
          }, {
            value: "B",
            text: "Concrete Block"
          }, {
            value: "BarnPlank",
            text: "Barn Plank"
          }, {
            value: "BevWd",
            text: "Beveled Wood/Clapboards"
          }, {
            value: "BlkDecPnt",
            text: "Block Decorative Painted"
          }, {
            value: "BlkPnt",
            text: "Block Painted"
          }, {
            value: "Board",
            text: "Board"
          }, {
            value: "BrdBat",
            text: "Baord and Batten"
          }, {
            value: "Brick",
            text: "Brick"
          }, {
            value: "BrkBlk",
            text: "Brick and Block"
          }, {
            value: "BrkBlkCus",
            text: "Brick and Block Custom"
          }, {
            value: "BrkCom",
            text: "Common Solid Brick"
          }, {
            value: "BrkFace",
            text: "Face Brick"
          }, {
            value: "BrkSol",
            text: "Solid Brick"
          }, {
            value: "BrkSolCus",
            text: "Solid Brick Custom"
          }, {
            value: "BrStone",
            text: "Solid BrownStone"
          }, {
            value: "C",
            text: "Steel"
          }, {
            value: "CatIII",
            text: "Category III"
          }, {
            value: "Cblock",
            text: "Cement/Concrete Block"
          }, {
            value: "CEDRK",
            text: "Cedar Shakes"
          }, {
            value: "Clapboard",
            text: "Clapboard"
          }, {
            value: "ClapRedWd",
            text: "Clapboard/Redwood"
          }, {
            value: "ConPour",
            text: "Poured Concrete"
          }, {
            value: "F",
            text: "Frame"
          }, {
            value: "G",
            text: "Adobe"
          }, {
            value: "Htile",
            text: "Hollow Tile"
          }, {
            value: "I",
            text: "PlasticVinyl Siding"
          }, {
            value: "JM",
            text: "Joisted Masonry"
          }, {
            value: "MNC",
            text: "Masonry Non Cumbustible"
          }, {
            value: "MY",
            text: "Masonry Non Cumbustible"
          }, {
            value: "N",
            text: "Metal/Aluminum Siding"
          }, {
            value: "NC",
            text: "Non Combustible"
          }, {
            value: "OT",
            text: "Other"
          }, {
            value: "P",
            text: "Pre-Fabricated"
          }, {
            value: "Pconcrete",
            text: "Plain Concrete"
          }, {
            value: "Pmasonry",
            text: "Painted Masonry"
          }, {
            value: "Preconcrete",
            text: "Precast Concrete"
          }, {
            value: "PreMetal",
            text: "PreEngineered Metal"
          }, {
            value: "PreStone",
            text: "Precast Stone"
          }, {
            value: "R",
            text: "Fire Resistive Superior"
          }, {
            value: "Rconcrete",
            text: "Reinforced Concrete"
          }, {
            value: "S",
            text: "Metal/Plastic Siding"
          }, {
            value: "SheetMetal",
            text: "Sheet Metal"
          }, {
            value: "SlumpBlock",
            text: "Slump Block"
          }, {
            value: "SMNC",
            text: "Superior Masonry Non Combustive"
          }, {
            value: "SNC",
            text: "Superior Non Combustible"
          }, {
            value: "SplitBlock",
            text: "Split Block"
          }, {
            value: "Sstone",
            text: "Solid Stone"
          }, {
            value: "Steel",
            text: "Steel"
          }, {
            value: "SteelF",
            text: "Steel Frame"
          }, {
            value: "SteelSid",
            text: "Steel Siding"
          }, {
            value: "Stone",
            text: "Granite/Stone"
          }, {
            value: "StoneBlk",
            text: "Stone and Block"
          }, {
            value: "StoneBlkCus",
            text: "Stone and Block Custom"
          }, {
            value: "StoneCult",
            text: "Artificial Cultured Stone"
          }, {
            value: "StoneNatv",
            text: "Native Stone"
          }, {
            value: "StoneSolCus",
            text: "Solid Stone Custom"
          }, {
            value: "StuccoC",
            text: "Stucco on Concrete Block"
          }, {
            value: "StuccoM",
            text: "Stucco on Masonry"
          }, {
            value: "T111",
            text: "T111 Siding"
          }, {
            value: "TiltUp",
            text: "Concrete Tilt-Up"
          }, {
            value: "Vinyl",
            text: "Vinyl"
          }, {
            value: "VSS",
            text: "Victorian Scalloped Shakes"
          }, {
            value: "Wood",
            text: "Wood and or Plaster Board"
          }, {
            value: "WoodSid",
            text: "Wood Siding"
          }, {
            value: "Wshakes",
            text: "Wood Shakes"
          }]
        };
      }
    }, {
      key: "getSWSPPOptions",
      value: function () {
        return [{
          value: "71",
          text: "Personal Jewelry"
        }, {
          value: "91",
          text: "Personal Furs"
        }, {
          value: "141",
          text: "Golfer Equipment"
        }, {
          value: "144",
          text: "Silverware"
        }, {
          value: "190",
          text: "Cameras/Non Commercial"
        }, {
          value: "335A",
          text: "Fine Arts - No Breakage"
        }, {
          value: "336A",
          text: "Fine Arts - With Breakage"
        }, {
          value: "450",
          text: "Musical Instrument-Individual"
        }, {
          value: "142",
          text: "Guns-Collected"
        }, {
          value: "143",
          text: "Guns-Fired"
        }];
      }
    }, {
      key: "getSWLenderOptions",
      value: function () {
        return [{
          id: "1",
          lenderName: "AMERICAN PACIFIC MORT CORP",
          address1: "ITS SUCCESSORS AND/OR ASSIGNS",
          address2: "3000 LAVA RIDGE COURT, STE 200",
          city: "ROSEVILLE",
          state: "CA",
          zipcode: "95661",
          text: "AMERICAN PACIFIC MORT CORP--3000 LAVA RIDGE COURT, STE 200 ROSEVILLE, 95661"
        }, {
          id: "2",
          lenderName: "BANK OF AMERICA, N.A.",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 961291",
          city: "FORT WORTH",
          state: "TX",
          zipcode: "761610291",
          text: "BANK OF AMERICA, N.A.--PO BOX 961291 FORT WORTH, 76161"
        }, {
          id: "3",
          lenderName: "CENLAR FSB C/O CENTRAL LOAN",
          address1: "ADMINISTRATION & REPORTING",
          address2: "ISAOA PO BOX 202028",
          city: "FLORENCE",
          state: "SC",
          zipcode: "295022028",
          text: "CENLAR FSB C/O CENTRAL LOAN--ISAOA PO BOX 202028 FLORENCE, 29502"
        }, {
          id: "4",
          lenderName: "DITECH FINANCIAL LLC",
          address1: "ITS AFFILIATES AND/OR ASSIGNS",
          address2: "PO BOX 979282",
          city: "MIAMI",
          state: "FL",
          zipcode: "331979282",
          text: "DITECH FINANCIAL LLC--PO BOX 979282 MIAMI, 33197"
        }, {
          id: "5",
          lenderName: "DOVENMUEHLE MORTGAGE INC",
          address1: "ISAOA",
          address2: "PO BOX 961292",
          city: "FORT WORTH",
          state: "TX",
          zipcode: "761610292",
          text: "DOVENMUEHLE MORTGAGE INC--PO BOX 961292 FORT WORTH, 76161"
        }, {
          id: "6",
          lenderName: "FLAGSTAR BANK FSB",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 52198",
          city: "PHOENIX",
          state: "AZ",
          zipcode: "850722198",
          text: "FLAGSTAR BANK FSB--PO BOX 52198 PHOENIX, 85072"
        }, {
          id: "7",
          lenderName: "JPMORGAN CHASE BANK N.A.",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 100564",
          city: "FLORENCE",
          state: "SC",
          zipcode: "295020564",
          text: "JPMORGAN CHASE BANK N.A.--PO BOX 100564 FLORENCE, 29502"
        }, {
          id: "8",
          lenderName: "JPMORGAN CHASE BANK N.A.",
          address1: "ISAOA",
          address2: "PO BOX 47020",
          city: "ATLANTA",
          state: "GA",
          zipcode: "30362",
          text: "JPMORGAN CHASE BANK, N.A.--PO BOX 47020 ATLANTA, 30362"
        }, {
          id: "9",
          lenderName: "LAKEVIEW LOAN SERVICING, LLC",
          address1: "C/O LOANCARE LLC ISAOA/ATIMA",
          address2: "PO BOX 202049",
          city: "FLORENCE",
          state: "SC",
          zipcode: "295022049",
          text: "LAKEVIEW LOAN SERVICING, LLC--PO BOX 202049 FLORENCE, 29502"
        }, {
          id: "10",
          lenderName: "LOANCARE LLC",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 202049",
          city: "FLORENCE",
          state: "SC",
          zipcode: "295022049",
          text: "LOANCARE LLC--PO BOX 202049 FLORENCE, 29502"
        }, {
          id: "11",
          lenderName: "MIDLAND MORTAGE, A DIVISION OF",
          address1: "MIDFIRST BANK, ISAOA",
          address2: "PO BOX 163529",
          city: "FORT WORTH",
          state: "TX",
          zipcode: "761613529",
          text: "MIDLAND MORTAGE, A DIVISION OF--PO BOX 163529 FORT WORTH, 76161"
        }, {
          id: "12",
          lenderName: "OCWEN LOAN SERVICING LLC",
          address1: "ISAOA",
          address2: "PO BOX 6723",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455011552",
          text: "OCWEN LOAN SERVICING LLC--PO BOX 6723 SPRINGFIELD, 45501"
        }, {
          id: "13",
          lenderName: "OCWEN LOAN SERVICING LLC",
          address1: "ISAOA",
          address2: "PO BOX 6723",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455011552",
          text: "OCWEN LOAN SERVICING LLC--PO BOX 6723 SPRINGFIELD, 45501"
        }, {
          id: "14",
          lenderName: "PHH MORTGAGE SERVICES",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 5954",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455015954",
          text: "PHH MORTGAGE SERVICES--PO BOX 5954 SPRINGFIELD, 45501"
        }, {
          id: "15",
          lenderName: "PNC BANK NA",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 7433",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455017433",
          text: "PNC BANK NA--PO BOX 7433 SPRINGFIELD, 45501"
        }, {
          id: "16",
          lenderName: "PROVIDENT FUNDING ASSOC, LP",
          address1: "ISAOA",
          address2: "PO BOX 5914",
          city: "SANTA ROSA",
          state: "CA",
          zipcode: "954025914",
          text: "PROVIDENT FUNDING ASSOC, LP--PO BOX 5914 SANTA ROSA, 95402"
        }, {
          id: "17",
          lenderName: "QUICKEN LOANS LLC",
          address1: "ISAOA",
          address2: "PO BOX 202070",
          city: "FLORENCE",
          state: "SC",
          zipcode: "29502",
          text: "QUICKEN LOANS LLC--PO BOX 202070 FLORENCE, 29502"
        }, {
          id: "18",
          lenderName: "SELECT PORTFOLIO SERVICING,INC",
          address1: "AS SERVICER, ISAOA",
          address2: "PO BOX 7277",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455017277",
          text: "SELECT PORTFOLIO SERVICING,INC--PO BOX 7277 SPRINGFIELD, 45501"
        }, {
          id: "19",
          lenderName: "TRUIST BANK",
          address1: "ISAOA ATIMA",
          address2: "PO BOX 7952",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "45501",
          text: "TRUIST BANK--PO BOX 7952 SPRINGFIELD, 45501"
        }, {
          id: "20",
          lenderName: "U.S. BANK NATIONAL ASSOCIATION",
          address1: "ISAOA C/O U.S. BANK HOME",
          address2: "MORTGAGE PO BOX 961045",
          city: "FORT WORTH",
          state: "TX",
          zipcode: "761610045",
          text: "U.S. BANK NATIONAL ASSOCIATION--MORTGAGE PO BOX 961045 FORT WORTH, 76161"
        }, {
          id: "21",
          lenderName: "US BANK NATIONAL ASSOCIATION",
          address1: "ISAOA C/O US BANK HOME",
          address2: "MORTGAGE PO BOX 961045",
          city: "FORT WORTH",
          state: "TX",
          zipcode: "761610045",
          text: "US BANK NATIONAL ASSOCIATION--MORTGAGE PO BOX 961045 FORT WORTH, 76161"
        }, {
          id: "22",
          lenderName: "WELLS FARGO BANK NA",
          address1: "ISAOA",
          address2: "PO BOX 8546",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "45501",
          text: "WELLS FARGO BANK NA--PO BOX 8546 SPRINGFIELD, 45501"
        }, {
          id: "23",
          lenderName: "WELLS FARGO BANK NA #936",
          address1: "ISAOA",
          address2: "PO BOX 100515",
          city: "FLORENCE",
          state: "SC",
          zipcode: "295020515",
          text: "WELLS FARGO BANK NA #936--PO BOX 100515 FLORENCE, 29502"
        }, {
          id: "24",
          lenderName: "WELLS FARGO BANK, NA #512",
          address1: "ITS SUCCESSORS AND/OR ASSIGNS",
          address2: "PO BOX 5708",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455015708",
          text: "WELLS FARGO BANK, NA #512--PO BOX 5708 SPRINGFIELD, 45501"
        }, {
          id: "25",
          lenderName: "WELLS FARGO HOME MORTGAGE #708",
          address1: "ITS SUCCESSORS AND/OR ASSIGNS",
          address2: "PO BOX 5708",
          city: "SPRINGFIELD",
          state: "OH",
          zipcode: "455015708",
          text: "WELLS FARGO HOME MORTGAGE #708--PO BOX 5708 SPRINGFIELD, 45501"
        }];
      }
    }, {
      key: "getSWPlansText",
      value: function () {
        return {
          economy: "Coverage designed to protect your home and belongings from any surprises",
          best: "Coverage designed with the best value for your money",
          expanded: "Coverage designed with a higher premium to cover higher liabilities on your assets"
        };
      }
    }, {
      key: "numberWithCommas",
      value: function (e) {
        return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }, {
      key: "getDiscountsSW",
      value: function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "1999",
          n = [{
            answer_label: "You are Married/Partnered/Widowed",
            inactive_image_url: "assets/images/SWAppFlow/ic-married.png",
            active_image_url: "assets/images/SWAppFlow/ic-married-active.png",
            amount: "10",
            answer_key: "sw_DiscountsPartneredWidowed",
            sw_questionId: 4965,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "Built by a company approved accredited home builder",
            inactive_image_url: "assets/images/SWAppFlow/ic-approved-builder.png",
            active_image_url: "assets/images/SWAppFlow/ic-approved-builder-active.png",
            amount: "20",
            answer_key: "sw_DiscountsApprovedBuilder",
            drop_down_values: this.getSWCABuilders(e),
            sw_questionId: 61,
            discount_type: "dropdown",
            hepl_text: ""
          }, {
            answer_label: "The residence has a smoke alarm, deadbolt, and a fire extinguisher",
            inactive_image_url: "assets/images/SWAppFlow/ic-smoke-alarm.png",
            active_image_url: "assets/images/SWAppFlow/ic-smoke-alarm-active.png",
            amount: "30",
            answer_key: "sw_DiscountsFireExtinguisher",
            sw_questionId: 4200,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has an active central station burglar alarm",
            inactive_image_url: "assets/images/SWAppFlow/ic-fire-safety.png",
            active_image_url: "assets/images/SWAppFlow/ic-fire-safety-active.png",
            amount: "40",
            answer_key: "sw_DiscountsFireAlarm",
            sw_questionId: 4255,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has an active central station reporting fire alarm",
            inactive_image_url: "assets/images/SWAppFlow/ic-burglar-alarm.png",
            active_image_url: "assets/images/SWAppFlow/ic-burglar-alarm-active.png",
            amount: "50",
            answer_key: "sw_DiscountsBurglarAlarm",
            sw_questionId: 4305,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The property is located in a gated community",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "60",
            answer_key: "sw_DiscountsGatedCommunity",
            sw_questionId: 9099,
            discount_type: "radio",
            hepl_text: "The property should be located in a gated community."
          }],
          a = [{
            answer_label: "You are Married/Partnered/Widowed",
            inactive_image_url: "assets/images/SWAppFlow/ic-married.png",
            active_image_url: "assets/images/SWAppFlow/ic-married-active.png",
            amount: "10",
            answer_key: "sw_DiscountsPartneredWidowed",
            sw_questionId: 4965,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "Built by a company approved accredited home builder",
            inactive_image_url: "assets/images/SWAppFlow/ic-approved-builder.png",
            active_image_url: "assets/images/SWAppFlow/ic-approved-builder-active.png",
            amount: "20",
            answer_key: "sw_DiscountsApprovedBuilder",
            drop_down_values: this.getSWCABuilders(e),
            sw_questionId: 61,
            discount_type: "dropdown",
            hepl_text: ""
          }, {
            answer_label: "The property is located in a gated community",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "60",
            answer_key: "sw_DiscountsGatedCommunity",
            sw_questionId: 9099,
            discount_type: "radio",
            hepl_text: "The property should be located in a gated community."
          }, {
            answer_label: "House has a hail-resistive roof",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsHailResistiveRoof",
            sw_questionId: 800,
            discount_type: "radio",
            hepl_text: "The property should have a hail-resistive roof made from a product with a minimum 15-year manufacturer's warranty on resistance to hail damage."
          }, {
            answer_label: "House is certified for installing the Roof Covering Credit",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsRoofCoverCredit",
            drop_down_values: [{
              text: "Class 1 UL Approved",
              value: "1"
            }, {
              text: "Class 2 UL Approved",
              value: "2"
            }, {
              text: "Class 3 UL Approved",
              value: "3"
            }, {
              text: "Class 4 UL Approved",
              value: "4"
            }, {
              text: "No Certificate of installation",
              value: "NO"
            }],
            sw_questionId: 1700,
            discount_type: "dropdown",
            hepl_text: "The owner should have the Certificate of Installation from state for Roof Covering Credit"
          }, {
            answer_label: "House has a valid Residential Fire Protection Sprinkler System",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsSprinklerSystem",
            drop_down_values: [{
              text: "Full Sprinkler with Certificate ",
              value: "FU"
            }, {
              text: "Partial Sprinkler with Certificate",
              value: "PT"
            }, {
              text: "Full Sprinkler without Certificate",
              value: "com.stillwater_FUwithoutCertificate"
            }, {
              text: "Partial Sprinkler without Certificate",
              value: "com.stillwater_PTwithoutCertificate"
            }, {
              text: "No Sprinkler",
              value: "NO"
            }],
            sw_questionId: 2e3,
            discount_type: "dropdown",
            hepl_text: ""
          }, {
            answer_label: "House has a Burglar Alarm System",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsBurglarAlarmSystem",
            sw_questionId: 4250,
            discount_type: "radio",
            hepl_text: "The residence should have a Burglar Alarm System for which you can provide a certificate(s) issued by either the Texas Department of Insurance or the security company that performed the installation or a current invoice from the security company itemizing the services being provided"
          }, {
            answer_label: "House has a central fire and burglar alarm system OR it is located in a secured area",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsSecuredArea",
            sw_questionId: 4301,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "House have a Dead-Bolt and Locking Devices",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsLockingDevice",
            sw_questionId: 4350,
            discount_type: "radio",
            hepl_text: "The residence should have Dead-Bolt and Locking Devices for which you can provide a certificate(s) issued by either the Texas Department of Insurance or the security company that performed the installation or a current invoice from the security company itemizing the services being provided."
          }],
          r = [{
            answer_label: "You are Married/Partnered/Widowed",
            inactive_image_url: "assets/images/SWAppFlow/ic-married.png",
            active_image_url: "assets/images/SWAppFlow/ic-married-active.png",
            amount: "10",
            answer_key: "sw_DiscountsPartneredWidowed",
            sw_questionId: 4965,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has a smoke alarm, deadbolt, and a fire extinguisher",
            inactive_image_url: "assets/images/SWAppFlow/ic-smoke-alarm.png",
            active_image_url: "assets/images/SWAppFlow/ic-smoke-alarm-active.png",
            amount: "30",
            answer_key: "sw_DiscountsFireExtinguisher",
            sw_questionId: 4200,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has an active central station burglar alarm",
            inactive_image_url: "assets/images/SWAppFlow/ic-fire-safety.png",
            active_image_url: "assets/images/SWAppFlow/ic-fire-safety-active.png",
            amount: "40",
            answer_key: "sw_DiscountsFireAlarm",
            sw_questionId: 4255,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has an active central station reporting fire alarm",
            inactive_image_url: "assets/images/SWAppFlow/ic-burglar-alarm.png",
            active_image_url: "assets/images/SWAppFlow/ic-burglar-alarm-active.png",
            amount: "50",
            answer_key: "sw_DiscountsBurglarAlarm",
            sw_questionId: 4305,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The property is located in a gated community",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "60",
            answer_key: "sw_DiscountsGatedCommunity",
            sw_questionId: 9099,
            discount_type: "radio",
            hepl_text: "The property should be located in a gated community."
          }],
          i = [{
            answer_label: "The residence has a smoke alarm, deadbolt, and a fire extinguisher",
            inactive_image_url: "assets/images/SWAppFlow/ic-smoke-alarm.png",
            active_image_url: "assets/images/SWAppFlow/ic-smoke-alarm-active.png",
            amount: "30",
            answer_key: "sw_DiscountsFireExtinguisher",
            sw_questionId: 4200,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has an active central station burglar alarm",
            inactive_image_url: "assets/images/SWAppFlow/ic-fire-safety.png",
            active_image_url: "assets/images/SWAppFlow/ic-fire-safety-active.png",
            amount: "40",
            answer_key: "sw_DiscountsFireAlarm",
            sw_questionId: 4255,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The residence has an active central station reporting fire alarm",
            inactive_image_url: "assets/images/SWAppFlow/ic-burglar-alarm.png",
            active_image_url: "assets/images/SWAppFlow/ic-burglar-alarm-active.png",
            amount: "50",
            answer_key: "sw_DiscountsBurglarAlarm",
            sw_questionId: 4305,
            discount_type: "radio",
            hepl_text: ""
          }, {
            answer_label: "The property is located in a gated community",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "60",
            answer_key: "sw_DiscountsGatedCommunity",
            sw_questionId: 9099,
            discount_type: "radio",
            hepl_text: "The property should be located in a gated community."
          }, {
            answer_label: "Built by a company approved accredited home builder",
            inactive_image_url: "assets/images/SWAppFlow/ic-approved-builder.png",
            active_image_url: "assets/images/SWAppFlow/ic-approved-builder-active.png",
            amount: "20",
            answer_key: "sw_DiscountsApprovedBuilder",
            drop_down_values: this.getSWCABuilders(e),
            sw_questionId: 61,
            discount_type: "dropdown",
            hepl_text: ""
          }, {
            answer_label: "Dwelling was built with a Construction Permit",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "60",
            answer_key: "sw_DwellingConstructionPermit",
            sw_questionId: 1150,
            discount_type: "radio",
            hepl_text: "The Construction Permit must be dated prior to March 1, 2002. Additional discounts may be available depending on the construction techniques utilized and the windstorm protective features of the structure. To be eligible for the premium adjustment, a qualified inspector must be retained, at the insured's expense, to complete the Windstorm Loss Reduction questionnaire. Once the form has been correctly completed and returned, the appropriate discount will be determined."
          }, {
            answer_label: "What is the shape of the roof?",
            inactive_image_url: "assets/images/SWAppFlow/ic-approved-builder.png",
            active_image_url: "assets/images/SWAppFlow/ic-approved-builder-active.png",
            amount: "60",
            answer_key: "sw_Shapeofroofis",
            drop_down_values: [{
              text: "Hip Roof",
              value: "HIP"
            }, {
              text: "Hip Roof - PYRAMID",
              value: "PYRAMID"
            }, {
              text: "Unknown",
              value: "UN"
            }, {
              text: "Other Shape - COMPLEX",
              value: "COMPLEX"
            }, {
              text: "Other Shape - GABLEBRACE",
              value: "GABLEBRACE"
            }, {
              text: "Other Shape - GAMBREL",
              value: "GAMBREL"
            }, {
              text: "Other Shape - MANSARD",
              value: "MANSARD"
            }, {
              text: "Other Shape - SHED",
              value: "SHED"
            }, {
              text: "Other Shape - STEPPED",
              value: "STEPPED"
            }],
            sw_questionId: 1205,
            discount_type: "dropdown",
            hepl_text: ""
          }];
        if ("CA" == e) {
          var o = new Date().getFullYear(),
            s = Number(o) - Number(t);
          if (Number(s) <= 6) return n;
          var l = n.filter(function (e) {
            return 61 != e.sw_questionId;
          });
          return l;
        }
        if ("TX" == e) {
          var u = new Date().getFullYear(),
            c = Number(u) - Number(t);
          if (Number(c) <= 6) return a;
          var m = a.filter(function (e) {
            return 61 != e.sw_questionId;
          });
          return m;
        }
        if ("CO" == e) {
          var p = {
            answer_label: "House has a hail-resistive roof",
            inactive_image_url: "assets/images/SWAppFlow/ic-gated-community.png",
            active_image_url: "assets/images/SWAppFlow/ic-gated-community-active.png",
            amount: "0",
            answer_key: "sw_DiscountsHailResistiveRoof",
            sw_questionId: 800
          };
          return r.push(p), r;
        }
        if ("FL" == e) {
          var d = new Date().getFullYear(),
            g = Number(d) - Number(t);
          return Number(g), i;
        }
        return r;
      }
    }, {
      key: "sbliinitApp",
      value: (D = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.initApp(t, a);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return D.apply(this, arguments);
      })
    }, {
      key: "sbliupdatePII",
      value: (H = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.updatePII(t, a);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return H.apply(this, arguments);
      })
    }, {
      key: "sbligetAPPQ",
      value: (k = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.getAPPQ(t, a);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return k.apply(this, arguments);
      })
    }, {
      key: "sblisubmitAPPQA",
      value: (R = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.submitAPPQA(a.arcId, a, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return R.apply(this, arguments);
      })
    }, {
      key: "sblisubmitAUTH",
      value: (N = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new SbliHelper.SbliHelper(t), e.next = 10, a.submitAUTH(n.arcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return N.apply(this, arguments);
      })
    }, {
      key: "sbligetDECISION",
      value: (O = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new SbliHelper.SbliHelper(t), e.next = 10, a.getDECISION(n.arcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return O.apply(this, arguments);
      })
    }, {
      key: "sbligetFORMS",
      value: (T = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.getFORMS(a.arcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return T.apply(this, arguments);
      })
    }, {
      key: "sblisubmitBENE",
      value: (I = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new SbliHelper.SbliHelper(t), e.next = 10, a.submitBENE(n.arcId, n.SBLI);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return I.apply(this, arguments);
      })
    }, {
      key: "sbligetPREMIUM",
      value: (P = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.getPREMIUM(a.arcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return P.apply(this, arguments);
      })
    }, {
      key: "sbliofferACCEPTANCE",
      value: (f = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.offerACCEPTANCE(a.arcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return f.apply(this, arguments);
      })
    }, {
      key: "sbliappSIGN",
      value: (x = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, a = n.state ? n.state : n.stateCode ? n.stateCode : n.state_name ? n.state_name : n.SBLI.SBLI_confirmDetailsState, console.log("APP DATA appJson :", n), console.log("libarary_state", a), r = new SbliHelper.SbliHelper(t), e.next = 12, r.appSIGN(a, n.arcId);
            case 12:
              return i = e.sent, e.abrupt("return", i);
            case 14:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return x.apply(this, arguments);
      })
    }, {
      key: "sblisubmitPAYINFO_deprecated",
      value: (A = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new SbliHelper.SbliHelper(t), e.next = 10, a.submitPAYINFO(n, n.SBLI);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return A.apply(this, arguments);
      })
    }, {
      key: "sblisubmitPAYINFO",
      value: (b = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t,
          n,
          a,
          r,
          i,
          o = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = o.length > 0 && void 0 !== o[0] ? o[0] : {}, n = this.getClientId(), e.next = 4, backendService.getAppData(n);
            case 4:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 11, r.submitPAYINFO(a, a.SBLI, t);
            case 11:
              return i = e.sent, e.abrupt("return", i);
            case 13:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return b.apply(this, arguments);
      })
    }, {
      key: "sbligetPOLICYNUMBER",
      value: (S = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new SbliHelper.SbliHelper(t), e.next = 10, a.getPOLICYNUMBER(n.arcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return S.apply(this, arguments);
      })
    }, {
      key: "sbliupdateSESSION",
      value: (v = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new SbliHelper.SbliHelper(n), e.next = 10, r.updateSESSION(a.arcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return v.apply(this, arguments);
      })
    }, {
      key: "wnsinitApp",
      value: (C = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.initApp(t, a);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return C.apply(this, arguments);
      })
    }, {
      key: "wnsupdatePII",
      value: (w = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.updatePII(t, a);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return w.apply(this, arguments);
      })
    }, {
      key: "wnsgetAPPQ",
      value: (h = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.getAPPQ(t, a);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return h.apply(this, arguments);
      })
    }, {
      key: "wnssubmitAPPQA",
      value: (y = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.submitAPPQA(a.wnsarcId, a, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return y.apply(this, arguments);
      })
    }, {
      key: "wnssubmitAUTH",
      value: (_ = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new WnsHelper.WnsHelper(t), e.next = 10, a.submitAUTH(n.wnsarcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return _.apply(this, arguments);
      })
    }, {
      key: "wnsgetDECISION",
      value: (g = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new WnsHelper.WnsHelper(t), e.next = 10, a.getDECISION(n.wnsarcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return g.apply(this, arguments);
      })
    }, {
      key: "wnsgetFORMS",
      value: (d = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.getFORMS(a.wnsarcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return d.apply(this, arguments);
      })
    }, {
      key: "wnssubmitBENE",
      value: (p = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new WnsHelper.WnsHelper(t), e.next = 10, a.submitBENE(n.wnsarcId, n.SBLI);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return p.apply(this, arguments);
      })
    }, {
      key: "wnsgetPREMIUM",
      value: (m = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.getPREMIUM(a.wnsarcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return m.apply(this, arguments);
      })
    }, {
      key: "wnsofferACCEPTANCE",
      value: (c = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.offerACCEPTANCE(a.wnsarcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return c.apply(this, arguments);
      })
    }, {
      key: "wnsappSIGN",
      value: (u = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new WnsHelper.WnsHelper(t), e.next = 10, a.appSIGN(n.wnsarcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return u.apply(this, arguments);
      })
    }, {
      key: "wnssubmitPAYINFO",
      value: (l = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t,
          n,
          a,
          r,
          i,
          o = arguments;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = o.length > 0 && void 0 !== o[0] ? o[0] : "", n = this.getClientId(), e.next = 4, backendService.getAppData(n);
            case 4:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 11, r.submitPAYINFO(a, a.SBLI, t);
            case 11:
              return i = e.sent, e.abrupt("return", i);
            case 13:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return l.apply(this, arguments);
      })
    }, {
      key: "wnsgetPOLICYNUMBER",
      value: (s = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = this.getClientId(), e.next = 3, backendService.getAppData(t);
            case 3:
              return n = e.sent, n = (n = JSON.parse(n.Payload)).body, console.log("APP DATA appJson :", n), a = new WnsHelper.WnsHelper(t), e.next = 10, a.getPOLICYNUMBER(n.wnsarcId);
            case 10:
              return r = e.sent, e.abrupt("return", r);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function () {
        return s.apply(this, arguments);
      })
    }, {
      key: "wnsupdateSESSION",
      value: (o = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r, i;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), e.next = 3, backendService.getAppData(n);
            case 3:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, console.log("APP DATA appJson :", a), r = new WnsHelper.WnsHelper(n), e.next = 10, r.updateSESSION(a.wnsarcId, t);
            case 10:
              return i = e.sent, e.abrupt("return", i);
            case 12:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return o.apply(this, arguments);
      })
    }, {
      key: "wnsPayment",
      value: (i = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), t.cardNumber || (t = {
                cardNumber: "4111111111111111",
                cardExpirationMonth: "12",
                cardExpirationYear: "24",
                totalAmount: "50",
                currency: "USD",
                firstName: "John",
                lastName: "Doe",
                address1: "1 Market St",
                locality: "san francisco",
                administrativeArea: "CA",
                postalCode: "94105",
                country: "US",
                email: "test@cybs.com",
                phoneNumber: "4158880000"
              }), e.prev = 2, e.next = 5, backendService.getWNSPayment(t, n + "_wnspayment");
            case 5:
              return a = e.sent, a = (a = JSON.parse(a.Payload)).body, r = {
                statusCode: a.output[0]["output.statusCode"],
                message: a.output[0]["output.message"],
                result: a.output[0]["output.result"]
              }, console.log(r), e.abrupt("return", r);
            case 13:
              return e.prev = 13, e.t0 = e.catch(2), e.abrupt("return", {
                statusCode: "500",
                message: "Failed",
                result: "Failed"
              });
            case 16:
            case "end":
              return e.stop();
          }
        }, e, this, [[2, 13]]);
      })), function (e) {
        return i.apply(this, arguments);
      })
    }, {
      key: "wnscyberpayment",
      value: (r = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
        var n, a, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return n = this.getClientId(), a = new WnsHelper.WnsHelper(n), e.next = 4, a.wnscyberpayment(t);
            case 4:
              return r = e.sent, e.abrupt("return", r);
            case 6:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e) {
        return r.apply(this, arguments);
      })
    }, {
      key: "getSbliquotes",
      value: (a = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, n) {
        var a, r, i, o, s;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return r = new SbliHelper.SbliHelper(this.getClientId()), e.next = 3, backendService.getAppData(n);
            case 3:
              if (i = e.sent, i = (i = JSON.parse(i.Payload)).body, console.log("sbliCommonInput : ", t), null == i.arcId || null == i.arcId || "" == i.arcId) {
                e.next = 14;
                break;
              }
              return e.next = 11, r.getQuote(t, i.arcId).then(function (e) {
                a = e;
              }).catch(function (e) {
                a = "error", console.log("wnserror", e);
              });
            case 11:
              return e.abrupt("return", a);
            case 14:
              return e.next = 16, r.initSESSION();
            case 16:
              return o = e.sent, console.log("initSESSIONres : ", o), e.next = 20, backendService.getAppData(n);
            case 20:
              return s = e.sent, s = (s = JSON.parse(s.Payload)).body, e.next = 25, r.getQuote(t, s.arcId).then(function (e) {
                a = e;
              }).catch(function (e) {
                a = "error", console.log("wnserror", e);
              });
            case 25:
              return e.abrupt("return", a);
            case 26:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return a.apply(this, arguments);
      })
    }, {
      key: "getWnsquotes",
      value: (n = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, n) {
        var a, r, i, o, s;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return r = new WnsHelper.WnsHelper(this.getClientId()), e.next = 3, backendService.getAppData(n);
            case 3:
              if (i = e.sent, null == (i = (i = JSON.parse(i.Payload)).body).wnsarcId || null == i.wnsarcId || "" == i.wnsarcId) {
                e.next = 12;
                break;
              }
              return e.next = 9, r.getQuote(t, i.wnsarcId).then(function (e) {
                a = e;
              }).catch(function (e) {
                a = "error", console.log("wnserror", e);
              });
            case 9:
              return e.abrupt("return", a);
            case 12:
              return e.next = 14, r.initSESSION();
            case 14:
              return o = e.sent, console.log("initSESSIONres : ", o), e.next = 18, backendService.getAppData(n);
            case 18:
              return s = e.sent, s = (s = JSON.parse(s.Payload)).body, e.next = 23, r.getQuote(t, s.wnsarcId).then(function (e) {
                a = e;
              }).catch(function (e) {
                a = "error", console.log("wnserror", e);
              });
            case 23:
              return e.abrupt("return", a);
            case 24:
            case "end":
              return e.stop();
          }
        }, e, this);
      })), function (e, t) {
        return n.apply(this, arguments);
      })
    }, {
      key: "getpaclifequotes",
      value: (t = _asyncToGenerator(_regeneratorRuntime.mark(function e(t, n, a, r, i) {
        var o, s, l, u, c, m;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              if (!(Number(n) >= 25e4)) {
                e.next = 28;
                break;
              }
              return e.prev = 1, console.log("paclifeBaseUrl: ", t + "/paclife/quote"), console.log("paclife start: "), e.next = 6, axios({
                method: "post",
                url: t + "/paclife/quote",
                data: a,
                timeout: 3e4
              });
            case 6:
              o = e.sent, e.next = 12;
              break;
            case 9:
              e.prev = 9, e.t0 = e.catch(1), console.log("paclifeOutput error", e.t0);
            case 12:
              if (console.log("paclife end: "), !o) {
                e.next = 28;
                break;
              }
              return console.log("paclifeOutput: ", o.data), l = flatten(o.data), e.next = 18, backendService.saveUpdateClientData(r, {
                paclifeQuote: l,
                quoteId: i,
                id: r,
                clientId: r,
                uid: r
              });
            case 18:
              return e.sent, e.next = 21, utilityModule.getClientId();
            case 21:
              for (m in u = e.sent, c = {
                id: u,
                clientId: u,
                uid: u,
                eventStr: "PaclifeCarrierQuote",
                dataCategory: "CarrierQuote"
              }, l) c[m] ? c["duplicate_" + m] = l[m] ? l[m] : "empty" : c[m] = l[m] ? l[m] : "empty";
              return e.next = 26, backendService.saveUpdateClientData(u, c);
            case 26:
              return s = this.getPaclifeAmount(o.data), e.abrupt("return", s);
            case 28:
            case "end":
              return e.stop();
          }
        }, e, this, [[1, 9]]);
      })), function (e, n, a, r, i) {
        return t.apply(this, arguments);
      })
    }, {
      key: "testSwHelper",
      value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e() {
        var t, n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) switch (e.prev = e.next) {
            case 0:
              return t = new StillWaterHelper.StillWaterHelper(), e.next = 3, t.getCoverageConfigBo("AZ", "06", "plan_4", "2010", null);
            case 3:
              return n = e.sent, e.abrupt("return", n);
            case 5:
            case "end":
              return e.stop();
          }
        }, e);
      })), function () {
        return e.apply(this, arguments);
      })
    }]);
    var e, t, n, a, r, i, o, s, l, u, c, m, p, d, g, _, y, h, w, C, v, S, b, A, x, f, P, I, T, O, N, R, k, H, D, W, L, F, M, E, B, G, q, U, Q, J, $, z, V, X, K, Y, Z, j, ee, te;
  }();
module.exports = {
  Quote: Quote
};